webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeApiFilterUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = makeApiUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = makeGetByIdUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = makeAutocompleteUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings__ = __webpack_require__(83);


function makeApiFilterUrl(slug) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var queryUrl = __WEBPACK_IMPORTED_MODULE_0__settings__["a" /* apiBaseUrl */]["production"] + slug + '?';

  if (filters !== null) {
    if (filters.startDate) {
      queryUrl += 'start_date=' + filters.startDate + '&';
    }

    if (filters.endDate) {
      queryUrl += 'end_date=' + filters.endDate + '&';
    }

    if (filters.map) {
      if (filters.map.active === 1) {
        queryUrl += 'ne=' + filters.map.bounds.ne.lat + ',' + filters.map.bounds.ne.lng + '&' + 'sw=' + filters.map.bounds.sw.lat + ',' + filters.map.bounds.sw.lng + '&';
      }
    }

    if (filters.params) {
      queryUrl += filters.params;
    }
  }

  return queryUrl;
}

function makeApiUrl(slug) {
  return __WEBPACK_IMPORTED_MODULE_0__settings__["a" /* apiBaseUrl */]["production"] + slug;
}

function makeGetByIdUrl(slug, ids) {
  return __WEBPACK_IMPORTED_MODULE_0__settings__["a" /* apiBaseUrl */]["production"] + slug + '?ids=' + ids;
}

function makeAutocompleteUrl(slug, terms) {
  return __WEBPACK_IMPORTED_MODULE_0__settings__["a" /* apiBaseUrl */]["production"] + slug + '?terms=' + terms;
}

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  addressTypes: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.addressTypes = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.addressTypes = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.addressTypes;
  }
};

var AddressTypes = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollisionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  collisionTypes: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.collisionTypes = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.collisionTypes = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.collisionTypes;
  }
};

var CollisionTypes = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DamageCosts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  damageCosts: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.damageCosts = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.damageCosts = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.damageCosts;
  }
};

var DamageCosts = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JunctionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  junctionTypes: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.junctionTypes = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.junctionTypes = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.junctionTypes;
  }
};

var JunctionTypes = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LightConditions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  lightConditions: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.lightConditions = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.lightConditions = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.lightConditions;
  }
};

var LightConditions = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoadConditions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  roadConditions: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.roadConditions = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.roadConditions = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.roadConditions;
  }
};

var RoadConditions = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Weather; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = { amounts: [], total: '' };

var state = {
  weather: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.weather = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.weather = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.weather;
  }
};

var Weather = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = {};

var state = {
  info: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.info = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.info = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.info;
  }
};

var Info = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DamageCostsRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var DamageCostsRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DistractedDrivingRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var state = {
  ranks: []
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    state.ranks = [];
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2, fullList) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var DistractedDrivingRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FatalitiesRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var FatalitiesRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InjuriesRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, filters) {
    var commit = _ref.commit;

    commit('FETCH', filters);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var InjuriesRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParkedCarsHitRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var ParkedCarsHitRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeopleBikingRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var PeopleBikingRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeopleInvolvedRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, filters) {
    var commit = _ref.commit;

    commit('FETCH', filters);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var PeopleInvolvedRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeopleWalkingRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var PeopleWalkingRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PossibleInjuriesRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var PossibleInjuriesRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropertyDamageOnlyRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var PropertyDamageOnlyRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeriousInjuriesRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var SeriousInjuriesRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpeedingRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, filters) {
    var commit = _ref.commit;

    commit('FETCH', filters);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var SpeedingRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TotalCollisionsRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var TotalCollisionsRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnderTheInfluenceRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = [];

var state = {
  ranks: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.ranks = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.ranks = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.ranks;
  }
};

var UnderTheInfluenceRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonthlyCollisions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var defaultState = {
  amounts: [],
  average: '',
  total: ''
};

var state = {
  monthlyCollisions: defaultState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.monthlyCollisions = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.amount = defaultState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.monthlyCollisions.amounts;
  },
  average: function average(state) {
    return state.monthlyCollisions.avg;
  },
  total: function total(state) {
    return state.monthlyCollisions.total;
  }
};

var MonthlyCollisions = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeverityRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = {};

var state = {
  rankings: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.rankings = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.rankings = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.rankings;
  }
};

var SeverityRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WhoRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = {};

var state = {
  rankings: startState
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.rankings = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.rankings = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.rankings;
  }
};

var WhoRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullListRank; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var state = {
  list: [],
  options: {},
  active: false
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.list = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  SET_OPTIONS: function SET_OPTIONS(state, options) {
    state.options = options;
  },
  TOGGLE_ACTIVE: function TOGGLE_ACTIVE(state) {
    state.active = !state.active;
  },
  RESET: function RESET(state) {
    state.list = [];
    state.options = {};
    state.active = false;
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  },

  setOptions: function setOptions(_ref3, options) {
    var commit = _ref3.commit;

    commit('SET_OPTIONS', options);
  },

  toggleActive: function toggleActive(_ref4) {
    var commit = _ref4.commit;

    commit('TOGGLE_ACTIVE');
  }
};

var getters = {
  get: function get(state) {
    return state.list;
  },
  options: function options(state) {
    return state.options;
  },
  active: function active(state) {
    return state.active;
  },
  filters: function filters(state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    };
  }
};

var FullListRank = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return black; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return brown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chartColors; });
var apiBaseUrl = {
  development: 'https://seattlecollisions-backend.test/v1',
  production: 'https://api.seattlecollisions.timganter.io/v1'
};

var black = {
  default: '#000000',
  light: {},
  dark: {
    a: '#222222',
    b: '#444444',
    c: '#666666',
    gradient: {}
  }
};

var blue = {
  default: '#2457AB',
  light: {
    a: '#6589C4',
    b: '#BDCCE5',
    c: '#DEE6F3'
  },
  dark: {
    a: '#23457D',
    b: '#242E40',
    c: '#23262B',
    gradient: {}
  }
};

var brown = {
  default: '#645236',
  light: {
    a: '#95805D',
    b: '#BAA788',
    c: '#D9CDBB'
  },
  dark: {
    a: '#3C311D',
    b: '#2D261A',
    c: '#241E14',
    gradient: {}
  }
};

var green = {
  default: '#5B8939',
  light: {
    a: '#8CAC74',
    b: '#CDDBC3',
    c: '#E7EEE2'
  },
  dark: {
    a: '#4A682D',
    b: '#343D1E',
    c: '#2C2E1A',
    gradient: {}
  }
};

var orange = {
  default: '#EF780E',
  light: {
    a: '#F3A056',
    b: '#FAD6B6',
    c: '#FDEBDB'
  },
  dark: {
    a: '#B15C0F',
    b: '#613811',
    c: '#422B13',
    gradient: {}
  }
};

var pink = {
  default: '#E27FB7',
  light: {
    a: '#EAA5CC',
    b: '#F6D8E9',
    c: '#FBECF4'
  },
  dark: {
    a: '#A86185',
    b: '#5D3A44',
    c: '#402C2C',
    gradient: {}
  }
};

var purple = {
  default: '#7864AC',
  light: {
    a: '#A092C4',
    b: '#D6D0E6',
    c: '#EBE8F3'
  },
  dark: {
    a: '#5E4E7D',
    b: '#3D3241',
    c: '#30282B',
    gradient: {}
  }
};

var red = {
  default: '#CA4632',
  light: {
    a: '#D97D6F',
    b: '#EFC7C1',
    c: '#F7E4E1'
  },
  dark: {
    a: '#973928',
    b: '#56291C',
    c: '#3C2419',
    gradient: {}
  }
};

var teal = {
  default: '#398981',
  light: {
    a: '#74ACA6',
    b: '#C3DBD9',
    c: '#E2EEEC'
  },
  dark: {
    a: '#32685F',
    b: '#2A3D34',
    c: '#272E24',
    gradient: {}
  }
};

var yellow = {
  default: '#D9B940',
  light: {
    a: '#E4CE79',
    b: '#F3EAC5',
    c: '#FAF5E3'
  },
  dark: {
    a: '#A28A32',
    b: '#5A4C20',
    c: '#3F351B',
    gradient: {}
  }
};

var chartColors = [red.light.a, yellow.light.a, green.light.a, blue.light.a, orange.light.a, purple.light.a, brown.light.a, teal.light.a, pink.light.a, blue.light.b, teal.light.b, red.light.b, yellow.light.b, purple.light.b, green.light.b, orange.light.b, pink.light.b];

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_CityCouncilDistrict__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_CityCouncilDistrict___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_CityCouncilDistrict__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CityCouncilDistricts__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CityCouncilDistricts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_CityCouncilDistricts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CityCouncilDistrictRanks__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CityCouncilDistrictRanks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_CityCouncilDistrictRanks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Collisions__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Collisions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Collisions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Locations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Locations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Locations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Neighborhood__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Neighborhood___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Neighborhood__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Neighborhoods__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Neighborhoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Neighborhoods__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_NeighborhoodRanks__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_NeighborhoodRanks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_NeighborhoodRanks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_about_Data__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_about_Data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_about_Data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_about_Story__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_about_Story___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_about_Story__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_about_Technology__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_about_Technology___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_about_Technology__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_about_ToDo__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_about_ToDo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_about_ToDo__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{ path: '/', redirect: { name: 'collisionsIndex' } }, { name: 'collisionsIndex', path: '/collisions', component: __WEBPACK_IMPORTED_MODULE_6__views_Collisions___default.a }, {
    name: 'collisions',
    path: '/collisions/sd/:sd/ed/:ed/m/:m/nelat/:nelat/nelng/:nelng/swlat/:swlat/swlng/:swlng',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Collisions___default.a
  }, { name: 'locationsIndex', path: '/locations', component: __WEBPACK_IMPORTED_MODULE_7__views_Locations___default.a }, { name: 'locations', path: '/locations/lids/:lids', component: __WEBPACK_IMPORTED_MODULE_7__views_Locations___default.a }, {
    path: '/districts/city',
    redirect: { name: 'districts' },
    component: __WEBPACK_IMPORTED_MODULE_2__App___default.a,
    children: [{ name: 'cityCouncilDistrict', path: '/districts/city/id/:id', component: __WEBPACK_IMPORTED_MODULE_3__views_CityCouncilDistrict___default.a }, { name: 'cityCouncilDistricts', path: '/districts/cities', component: __WEBPACK_IMPORTED_MODULE_4__views_CityCouncilDistricts___default.a }, { name: 'cityCouncilDistrictRanksIndex', path: '/districts/city/ranks', component: __WEBPACK_IMPORTED_MODULE_5__views_CityCouncilDistrictRanks___default.a }, { name: 'cityCouncilDistrictRanks', path: '/districts/city/ranks/sd/:sd/ed/:ed', component: __WEBPACK_IMPORTED_MODULE_5__views_CityCouncilDistrictRanks___default.a }]
  }, {
    path: '/neighborhood',
    redirect: { name: 'neighborhood' },
    component: __WEBPACK_IMPORTED_MODULE_2__App___default.a,
    children: [{ name: 'neighborhood', path: '/neighborhood/:id', component: __WEBPACK_IMPORTED_MODULE_8__views_Neighborhood___default.a }, { name: 'neighborhoods', path: '/neighborhoods', component: __WEBPACK_IMPORTED_MODULE_9__views_Neighborhoods___default.a }, { name: 'neighborhoodRanksIndex', path: '/neighborhood/ranks', component: __WEBPACK_IMPORTED_MODULE_10__views_NeighborhoodRanks___default.a }, { name: 'neighborhoodRanks', path: '/neighborhood/ranks/sd/:sd/ed/:ed', component: __WEBPACK_IMPORTED_MODULE_10__views_NeighborhoodRanks___default.a }]
  }, {
    path: '/about',
    redirect: { name: 'story' },
    component: __WEBPACK_IMPORTED_MODULE_2__App___default.a,
    children: [{ name: 'story', path: 'story', component: __WEBPACK_IMPORTED_MODULE_12__views_about_Story___default.a }, { name: 'technology', path: 'technology', component: __WEBPACK_IMPORTED_MODULE_13__views_about_Technology___default.a }, { name: 'data', path: 'data', component: __WEBPACK_IMPORTED_MODULE_11__views_about_Data___default.a }, { name: 'toDo', path: 'todo', component: __WEBPACK_IMPORTED_MODULE_14__views_about_ToDo___default.a }]
  }]
}));

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters_FilterDateRange_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters_FilterLocations_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters_FilterMapActive_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters_FilterMapBounds_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_LocationsCollisions_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_CityCouncilDistrictView_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_CityCouncilDistrictsView_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_CityCouncilDistrictRanksView_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_CollisionsView_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_LocationsView_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_NeighborhoodView_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_NeighborhoodsView_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_NeighborhoodRanksView_js__ = __webpack_require__(266);




















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    filterDateRange: __WEBPACK_IMPORTED_MODULE_3__filters_FilterDateRange_js__["a" /* FilterDateRange */],
    filterLocations: __WEBPACK_IMPORTED_MODULE_4__filters_FilterLocations_js__["a" /* FilterLocations */],
    filterMapActive: __WEBPACK_IMPORTED_MODULE_5__filters_FilterMapActive_js__["a" /* FilterMapActive */],
    filterMapBounds: __WEBPACK_IMPORTED_MODULE_6__filters_FilterMapBounds_js__["a" /* FilterMapBounds */],
    locationsCollisions: __WEBPACK_IMPORTED_MODULE_7__modules_LocationsCollisions_js__["a" /* LocationsCollisions */],

    cityCouncilDistrictView: __WEBPACK_IMPORTED_MODULE_8__views_CityCouncilDistrictView_js__["a" /* CityCouncilDistrictView */],
    cityCouncilDistrictsView: __WEBPACK_IMPORTED_MODULE_9__views_CityCouncilDistrictsView_js__["a" /* CityCouncilDistrictsView */],
    cityCouncilDistrictRanksView: __WEBPACK_IMPORTED_MODULE_10__views_CityCouncilDistrictRanksView_js__["a" /* CityCouncilDistrictRanksView */],
    collisionsView: __WEBPACK_IMPORTED_MODULE_11__views_CollisionsView_js__["a" /* CollisionsView */],
    locationsView: __WEBPACK_IMPORTED_MODULE_12__views_LocationsView_js__["a" /* LocationsView */],
    neighborhoodView: __WEBPACK_IMPORTED_MODULE_13__views_NeighborhoodView_js__["a" /* NeighborhoodView */],
    neighborhoodsView: __WEBPACK_IMPORTED_MODULE_14__views_NeighborhoodsView_js__["a" /* NeighborhoodsView */],
    neighborhoodRanksView: __WEBPACK_IMPORTED_MODULE_15__views_NeighborhoodRanksView_js__["a" /* NeighborhoodRanksView */]
  },

  state: {},

  mutations: {},

  actions: {},

  getters: {
    chartColors: function chartColors(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* chartColors */];
    },

    black: function black(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["c" /* black */];
    },

    blue: function blue(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["d" /* blue */];
    },

    brown: function brown(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["e" /* brown */];
    },

    green: function green(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["f" /* green */];
    },

    orange: function orange(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["g" /* orange */];
    },

    pink: function pink(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["h" /* pink */];
    },

    purple: function purple(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["i" /* purple */];
    },

    red: function red(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["j" /* red */];
    },

    teal: function teal(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["k" /* teal */];
    },

    yellow: function yellow(state) {
      return __WEBPACK_IMPORTED_MODULE_2__settings__["l" /* yellow */];
    }
  }
}));

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(232);







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterDateRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var defaultStartDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()('2023-01-01').format('YYYY-MM-DD');
var defaultEndDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()('2023-06-01').format('YYYY-MM-DD');

var state = {
  startDate: defaultStartDate,
  endDate: defaultEndDate
};

var mutations = {
  SET_START_DATE: function SET_START_DATE(state, startDate) {
    state.startDate = startDate;
  },
  SET_END_DATE: function SET_END_DATE(state, endDate) {
    state.endDate = endDate;
  }
};

var actions = {
  setStartDate: function setStartDate(_ref, startDate) {
    var commit = _ref.commit;

    if (typeof startDate === 'undefined') {
      commit('SET_START_DATE', defaultStartDate);
    } else {
      commit('SET_START_DATE', startDate);
    }
  },

  setEndDate: function setEndDate(_ref2, endDate) {
    var commit = _ref2.commit;

    if (typeof endDate === 'undefined') {
      commit('SET_END_DATE', defaultEndDate);
    } else {
      commit('SET_END_DATE', endDate);
    }
  }
};

var getters = {
  startDate: function startDate(state) {
    return state.startDate;
  },

  endDate: function endDate(state) {
    return state.endDate;
  }
};

var FilterDateRange = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterLocations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(3);



var state = {
  selectedLocations: [],
  selectedLocationIds: [],
  results: []
};

var mutations = {
  SEARCH: function SEARCH(state, formInput) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* makeAutocompleteUrl */]('/autocomplete/locations', formInput)).then(function (response) {
      state.results = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  FETCH_LOCATIONS: function FETCH_LOCATIONS(state, locationIds) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* makeGetByIdUrl */]('/locations/descriptions', locationIds)).then(function (response) {
      state.selectedLocations = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  ADD_SELECTED_LOCATION_ID: function ADD_SELECTED_LOCATION_ID(state, locationId) {
    state.selectedLocationIds.push(locationId.toString());
  },
  REMOVE_SELECTED_LOCATION_ID: function REMOVE_SELECTED_LOCATION_ID(state, locationId) {
    var index = state.selectedLocationIds.indexOf(locationId.toString());
    if (index > -1) {
      state.selectedLocationIds.splice(index, 1);
    }
  },
  SET_SELECTED_LOCATION_IDS: function SET_SELECTED_LOCATION_IDS(state, locationIds) {
    state.selectedLocationIds = locationIds.split(',');
  }
};

var actions = {
  search: function search(_ref, formInput) {
    var commit = _ref.commit;

    commit('SEARCH', formInput);
  },

  setSelectedLocations: function setSelectedLocations(_ref2, locationIds) {
    var commit = _ref2.commit;

    commit('FETCH_LOCATIONS', locationIds);
  },

  setSelectedLocationIds: function setSelectedLocationIds(_ref3, locationIds) {
    var commit = _ref3.commit;

    commit('SET_SELECTED_LOCATION_IDS', locationIds);
  },

  addSelectedLocationId: function addSelectedLocationId(_ref4, locationId) {
    var commit = _ref4.commit;

    commit('ADD_SELECTED_LOCATION_ID', locationId);
  },

  removeSelectedLocationId: function removeSelectedLocationId(_ref5, locationId) {
    var commit = _ref5.commit;

    commit('REMOVE_SELECTED_LOCATION_ID', locationId);
  }
};

var getters = {
  results: function results(state) {
    return state.results;
  },
  selectedLocations: function selectedLocations(state) {
    return state.selectedLocations;
  },
  selectedLocationIds: function selectedLocationIds(state) {
    return state.selectedLocationIds;
  }
};

var FilterLocations = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterMapActive; });
var state = { active: 0 };

var mutations = {
  SET: function SET(state, active) {
    state.active = active;
  }
};

var actions = {
  set: function set(_ref, m) {
    var commit = _ref.commit;

    var active = m === '1' || m === 1 ? 1 : 0;
    commit('SET', active);
  }
};

var getters = {
  get: function get(state) {
    return state.active;
  }
};

var FilterMapActive = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterMapBounds; });
var state = {
  bounds: {
    ne: { lat: 47.79101617826261, lng: -122.20848083496095 },
    sw: { lat: 47.42111891027388, lng: -122.45567321777345 }
  }
};

var mutations = {
  SET: function SET(state, bounds) {
    state.bounds = bounds;
  }
};

var actions = {
  set: function set(_ref, bounds) {
    var commit = _ref.commit;

    commit('SET', bounds);
  }
};

var getters = {
  get: function get(state) {
    return state.bounds;
  }
};

var FilterMapBounds = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationsCollisions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(3);



var state = {
  results: []
};

var mutations = {
  FETCH: function FETCH(state, locationIds) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* makeGetByIdUrl */]('/locations/collisions', locationIds)).then(function (response) {
      state.results = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.results = [];
  }
};

var actions = {
  fetch: function fetch(_ref, locationIds) {
    var commit = _ref.commit;

    commit('FETCH', locationIds);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  results: function results(state) {
    return state.results;
  }
};

var LocationsCollisions = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Locations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var state = {
  locations: []
};

var mutations = {
  FETCH: function FETCH(state, params) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */](params.slug, params.filters)).then(function (response) {
      state.locations = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.locations = [];
  }
};

var actions = {
  fetch: function fetch(_ref, params) {
    var commit = _ref.commit;

    commit('FETCH', params);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.locations;
  }
};

var Locations = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Who; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = {};

var state = {
  who: startState
};

var mutations = {
  FETCH: function FETCH(state, filters) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */]('/who', filters)).then(function (response) {
      state.who = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.who = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, filters) {
    var commit = _ref.commit;

    commit('FETCH', filters);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.who;
  }
};

var Who = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collision; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = [];

var state = {
  collision: startState
};

var mutations = {
  FETCH: function FETCH(state, collisionId) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["b" /* makeApiUrl */]('/collisions/' + collisionId)).then(function (response) {
      state.collision = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.collision = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, collisionId) {
    var commit = _ref.commit;

    commit('FETCH', collisionId);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.collision;
  }
};

var Collision = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CityCouncilDistrictRanksView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_modules_barCharts_DamageCostsRank_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_DistractedDrivingRank_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_FatalitiesRank_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_InjuriesRank_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_ParkedCarsHitRank_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_PeopleBikingRank_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_PeopleInvolvedRank_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_PeopleWalkingRank_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_modules_barCharts_PossibleInjuriesRank_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_modules_barCharts_PropertyDamageOnlyRank_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_modules_barCharts_SeriousInjuriesRank_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex_modules_barCharts_SpeedingRank_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuex_modules_barCharts_TotalCollisionsRank_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuex_modules_barCharts_UnderTheInfluenceRank_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuex_modules_trays_FullListRank_js__ = __webpack_require__(82);

















var modules = {
  fullList: __WEBPACK_IMPORTED_MODULE_14__vuex_modules_trays_FullListRank_js__["a" /* FullListRank */],

  costs: __WEBPACK_IMPORTED_MODULE_0__vuex_modules_barCharts_DamageCostsRank_js__["a" /* DamageCostsRank */],
  distractedDriving: __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_DistractedDrivingRank_js__["a" /* DistractedDrivingRank */],
  fatalities: __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_FatalitiesRank_js__["a" /* FatalitiesRank */],
  injuries: __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_InjuriesRank_js__["a" /* InjuriesRank */],
  parkedCarsHit: __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_ParkedCarsHitRank_js__["a" /* ParkedCarsHitRank */],
  peopleBiking: __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_PeopleBikingRank_js__["a" /* PeopleBikingRank */],
  peopleInvolved: __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_PeopleInvolvedRank_js__["a" /* PeopleInvolvedRank */],
  peopleWalking: __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_PeopleWalkingRank_js__["a" /* PeopleWalkingRank */],
  possibleInjuries: __WEBPACK_IMPORTED_MODULE_8__vuex_modules_barCharts_PossibleInjuriesRank_js__["a" /* PossibleInjuriesRank */],
  propertyDamageOnly: __WEBPACK_IMPORTED_MODULE_9__vuex_modules_barCharts_PropertyDamageOnlyRank_js__["a" /* PropertyDamageOnlyRank */],
  seriousInjuries: __WEBPACK_IMPORTED_MODULE_10__vuex_modules_barCharts_SeriousInjuriesRank_js__["a" /* SeriousInjuriesRank */],
  speeding: __WEBPACK_IMPORTED_MODULE_11__vuex_modules_barCharts_SpeedingRank_js__["a" /* SpeedingRank */],
  totalCollisions: __WEBPACK_IMPORTED_MODULE_12__vuex_modules_barCharts_TotalCollisionsRank_js__["a" /* TotalCollisionsRank */],
  underTheInfluence: __WEBPACK_IMPORTED_MODULE_13__vuex_modules_barCharts_UnderTheInfluenceRank_js__["a" /* UnderTheInfluenceRank */]
};

var state = {
  resultsFilters: {}
};

var mutations = {
  SET_RESULTS_FILTERS: function SET_RESULTS_FILTERS(state, filters) {
    state.resultsFilters = filters;
  }
};

var actions = {
  fetchAll: function fetchAll(_ref, filters) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_RESULTS_FILTERS', filters);

    dispatch('costs/fetch', { slug: '/districts/city/ranks/costs/economic/desc', filters: filters });
    dispatch('distractedDriving/fetch', { slug: '/districts/city/ranks/who/inattentionind/desc', filters: filters });
    dispatch('fatalities/fetch', { slug: '/districts/city/ranks/severity/5/desc', filters: filters });
    dispatch('injuries/fetch', { slug: '/districts/city/ranks/severity/1/desc', filters: filters });
    dispatch('parkedCarsHit/fetch', { slug: '/districts/city/ranks/who/hitparkedcar/desc', filters: filters });
    dispatch('peopleBiking/fetch', { slug: '/districts/city/ranks/who/pedcylcount/desc', filters: filters });
    dispatch('peopleInvolved/fetch', { slug: '/districts/city/ranks/who/personcount/desc', filters: filters });
    dispatch('peopleWalking/fetch', { slug: '/districts/city/ranks/who/pedcount/desc', filters: filters });
    dispatch('possibleInjuries/fetch', { slug: '/districts/city/ranks/severity/3/desc', filters: filters });
    dispatch('propertyDamageOnly/fetch', { slug: '/districts/city/ranks/severity/2/desc', filters: filters });
    dispatch('seriousInjuries/fetch', { slug: '/districts/city/ranks/severity/4/desc', filters: filters });
    dispatch('speeding/fetch', { slug: '/districts/city/ranks/who/speeding/desc', filters: filters });
    dispatch('totalCollisions/fetch', { slug: '/districts/city/ranks/totalcollisions/desc', filters: filters });
    dispatch('underTheInfluence/fetch', { slug: '/districts/city/ranks/who/underinfl/desc', filters: filters });
  },

  setFilters: function setFilters(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    var startDate = typeof rootState.route.params.sd === 'undefined' ? '2006-01-01' : rootState.route.params.sd;

    dispatch('filterDateRange/setStartDate', startDate, { root: true });
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, { root: true });
  },

  resetResults: function resetResults(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('totalCollisions/reset');
    dispatch('costs/reset');
    dispatch('fatalities/reset');
    dispatch('seriousInjuries/reset');
    dispatch('injuries/reset');
    dispatch('propertyDamageOnly/reset');
    dispatch('possibleInjuries/reset');
    dispatch('peopleInvolved/reset');
    dispatch('peopleWalking/reset');
    dispatch('peopleBiking/reset');
    dispatch('parkedCarsHit/reset');
    dispatch('speeding/reset');
    dispatch('distractedDriving/reset');
    dispatch('underTheInfluence/reset');
  }
};

var getters = {
  filters: function filters(state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    };
  },


  resultsFilters: function resultsFilters(state) {
    return state.resultsFilters;
  }
};

var CityCouncilDistrictRanksView = {
  namespaced: true,
  modules: modules,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CityCouncilDistrictView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_modules_pageInfo_Info_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_AddressTypes_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_CollisionTypes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_DamageCosts_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_JunctionTypes_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_LightConditions_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_RoadConditions_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_Weather_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_modules_tables_WhoRank_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_modules_tables_SeverityRank_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_modules_lineCharts_MonthlyCollisions_js__ = __webpack_require__(79);














var modules = {
  pageInfo: __WEBPACK_IMPORTED_MODULE_0__vuex_modules_pageInfo_Info_js__["a" /* Info */],
  addressTypes: __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_AddressTypes_js__["a" /* AddressTypes */],
  collisionTypes: __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_CollisionTypes_js__["a" /* CollisionTypes */],
  damageCosts: __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_DamageCosts_js__["a" /* DamageCosts */],
  junctionTypes: __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_JunctionTypes_js__["a" /* JunctionTypes */],
  lightConditions: __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_LightConditions_js__["a" /* LightConditions */],
  roadConditions: __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_RoadConditions_js__["a" /* RoadConditions */],
  weather: __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_Weather_js__["a" /* Weather */],
  whoRank: __WEBPACK_IMPORTED_MODULE_8__vuex_modules_tables_WhoRank_js__["a" /* WhoRank */],
  severityRank: __WEBPACK_IMPORTED_MODULE_9__vuex_modules_tables_SeverityRank_js__["a" /* SeverityRank */],
  monthlyCollisions: __WEBPACK_IMPORTED_MODULE_10__vuex_modules_lineCharts_MonthlyCollisions_js__["a" /* MonthlyCollisions */]
};

var state = {
  resultsFilters: {}
};

var mutations = {
  SET_RESULTS_FILTERS: function SET_RESULTS_FILTERS(state, filters) {
    state.resultsFilters = filters;
  }
};

var actions = {
  fetchAll: function fetchAll(_ref, params) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_RESULTS_FILTERS', params.filters);
    dispatch('pageInfo/fetch', { slug: '/districts/city/' + params.id + '/info', filters: params.filters });

    dispatch('addressTypes/fetch', { slug: '/districts/city/' + params.id + '/address/types', filters: params.filters });
    dispatch('collisionTypes/fetch', { slug: '/districts/city/' + params.id + '/collision/types/', filters: params.filters });
    dispatch('damageCosts/fetch', { slug: '/districts/city/' + params.id + '/costs/economic', filters: params.filters });
    dispatch('junctionTypes/fetch', { slug: '/districts/city/' + params.id + '/junction/types/', filters: params.filters });
    dispatch('lightConditions/fetch', { slug: '/districts/city/' + params.id + '/light/conditions/', filters: params.filters });
    dispatch('roadConditions/fetch', { slug: '/districts/city/' + params.id + '/road/conditions/', filters: params.filters });
    dispatch('weather/fetch', { slug: '/districts/city/' + params.id + '/weather', filters: params.filters });
    dispatch('whoRank/fetch', { slug: '/districts/city/' + params.id + '/rankings/who', filters: params.filters });
    dispatch('severityRank/fetch', { slug: '/districts/city/' + params.id + '/rankings/severity', filters: params.filters });
    dispatch('monthlyCollisions/fetch', { slug: '/districts/city/' + params.id + '/monthlycollisions', filters: params.filters });
  },

  setFilters: function setFilters(_ref2) {
    var dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    var startDate = typeof rootState.route.params.sd === 'undefined' ? '2006-01-01' : rootState.route.params.sd;

    dispatch('filterDateRange/setStartDate', startDate, { root: true });
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, { root: true });
  },

  resetResults: function resetResults(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('pageInfo/reset');
    dispatch('addressTypes/reset');
    dispatch('collisionTypes/reset');
    dispatch('junctionTypes/reset');
    dispatch('lightConditions/reset');
    dispatch('roadConditions/reset');
    dispatch('weather/reset');
    dispatch('whoRank/reset');
    dispatch('severityRank/reset');
    dispatch('monthlyCollisions/reset');
    dispatch('damageCosts/reset');
  }
};

var getters = {
  filters: function filters(state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    };
  },


  resultsFilters: function resultsFilters(state) {
    return state.resultsFilters;
  }
};

var CityCouncilDistrictView = {
  namespaced: true,
  modules: modules,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CityCouncilDistrictsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = [];

var state = {
  districts: startState
};

var mutations = {
  FETCH: function FETCH(state) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["b" /* makeApiUrl */]('/districts/city/all')).then(function (response) {
      state.districts = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.districts = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, filters) {
    var commit = _ref.commit;

    commit('FETCH', filters);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.districts;
  }
};

var CityCouncilDistrictsView = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollisionsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_modules_pageInfo_Info_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_AddressTypes_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_CollisionTypes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_DamageCosts_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_JunctionTypes_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_LightConditions_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_RoadConditions_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_Weather_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_modules_maps_Locations_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_modules_tables_Who_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_modules_trays_Collision_js__ = __webpack_require__(260);

















var modules = {
  total: __WEBPACK_IMPORTED_MODULE_0__vuex_modules_pageInfo_Info_js__["a" /* Info */],

  addressTypes: __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_AddressTypes_js__["a" /* AddressTypes */],
  collision: __WEBPACK_IMPORTED_MODULE_10__vuex_modules_trays_Collision_js__["a" /* Collision */],
  collisionTypes: __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_CollisionTypes_js__["a" /* CollisionTypes */],
  collisionLocations: __WEBPACK_IMPORTED_MODULE_8__vuex_modules_maps_Locations_js__["a" /* Locations */],
  damageCosts: __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_DamageCosts_js__["a" /* DamageCosts */],
  junctionTypes: __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_JunctionTypes_js__["a" /* JunctionTypes */],
  lightConditions: __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_LightConditions_js__["a" /* LightConditions */],
  roadConditions: __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_RoadConditions_js__["a" /* RoadConditions */],
  weather: __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_Weather_js__["a" /* Weather */],
  who: __WEBPACK_IMPORTED_MODULE_9__vuex_modules_tables_Who_js__["a" /* Who */]
};

var state = {
  resultsFilters: {}
};

var mutations = {
  SET_RESULTS_FILTERS: function SET_RESULTS_FILTERS(state, filters) {
    state.resultsFilters = filters;
  }
};

var actions = {
  fetchAll: function fetchAll(_ref, filters) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_RESULTS_FILTERS', filters);

    dispatch('total/fetch', { slug: '/collisions/total', filters: filters });
    dispatch('collisionLocations/fetch', { slug: '/collisions/locations', filters: filters });
    dispatch('who/fetch', filters);

    dispatch('addressTypes/fetch', { slug: '/address/types', filters: filters });
    dispatch('collisionTypes/fetch', { slug: '/collision/types', filters: filters });
    dispatch('damageCosts/fetch', { slug: '/damage/costs/economic', filters: filters });
    dispatch('junctionTypes/fetch', { slug: '/junction/types', filters: filters });
    dispatch('lightConditions/fetch', { slug: '/light/conditions', filters: filters });
    dispatch('roadConditions/fetch', { slug: '/road/conditions', filters: filters });
    dispatch('weather/fetch', { slug: '/weathers', filters: filters });
  },

  setFilters: function setFilters(_ref2) {
    var dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    dispatch('filterDateRange/setStartDate', rootState.route.params.sd, { root: true });
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, { root: true });
    dispatch('filterMapActive/set', rootState.route.params.m, { root: true });
    dispatch('filterMapBounds/set', {
      ne: { lat: rootState.route.params.nelat, lng: rootState.route.params.nelng },
      sw: { lat: rootState.route.params.swlat, lng: rootState.route.params.swlng }
    }, { root: true });
  },

  resetResults: function resetResults(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('total/reset');

    dispatch('addressTypes/reset');
    dispatch('collisionLocations/reset');
    dispatch('collisionTypes/reset');
    dispatch('damageCosts/reset');
    dispatch('junctionTypes/reset');
    dispatch('lightConditions/reset');
    dispatch('roadConditions/reset');
    dispatch('weather/reset');
    dispatch('who/reset');
  }
};

var getters = {
  filters: function filters(state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate,
      map: {
        active: rootState.filterMapActive.active,
        bounds: rootState.filterMapBounds.bounds
      }
    };
  },


  resultsFilters: function resultsFilters(state) {
    return state.resultsFilters;
  }
};

var CollisionsView = {
  namespaced: true,
  modules: modules,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationsView; });
var actions = {
  fetchLocations: function fetchLocations(_ref, filters) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    dispatch('locationsCollisions/fetch', filters.selectedLocationIds, { root: true });
  },

  setFilters: function setFilters(_ref2) {
    var dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    dispatch('filterLocations/setSelectedLocations', rootState.route.params.lids, { root: true });
    dispatch('filterLocations/setSelectedLocationIds', rootState.route.params.lids, { root: true });
  },

  resetResults: function resetResults(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('locationsCollisions/reset', null, { root: true });
  }
};

var getters = {
  filters: function filters(state, getters, rootState, rootGetters) {
    return {
      selectedLocations: rootGetters['filterLocations/selectedLocations'],
      selectedLocationIds: rootGetters['filterLocations/selectedLocationIds']
    };
  }
};

var LocationsView = {
  namespaced: true,
  actions: actions,
  getters: getters
};

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NeighborhoodRanksView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_modules_barCharts_DamageCostsRank_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_DistractedDrivingRank_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_FatalitiesRank_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_InjuriesRank_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_ParkedCarsHitRank_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_PeopleBikingRank_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_PeopleInvolvedRank_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_PeopleWalkingRank_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_modules_barCharts_PossibleInjuriesRank_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_modules_barCharts_PropertyDamageOnlyRank_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_modules_barCharts_SeriousInjuriesRank_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex_modules_barCharts_SpeedingRank_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuex_modules_barCharts_TotalCollisionsRank_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuex_modules_barCharts_UnderTheInfluenceRank_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuex_modules_trays_FullListRank_js__ = __webpack_require__(82);

















var modules = {
  fullList: __WEBPACK_IMPORTED_MODULE_14__vuex_modules_trays_FullListRank_js__["a" /* FullListRank */],

  costs: __WEBPACK_IMPORTED_MODULE_0__vuex_modules_barCharts_DamageCostsRank_js__["a" /* DamageCostsRank */],
  distractedDriving: __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_DistractedDrivingRank_js__["a" /* DistractedDrivingRank */],
  fatalities: __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_FatalitiesRank_js__["a" /* FatalitiesRank */],
  injuries: __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_InjuriesRank_js__["a" /* InjuriesRank */],
  parkedCarsHit: __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_ParkedCarsHitRank_js__["a" /* ParkedCarsHitRank */],
  peopleBiking: __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_PeopleBikingRank_js__["a" /* PeopleBikingRank */],
  peopleInvolved: __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_PeopleInvolvedRank_js__["a" /* PeopleInvolvedRank */],
  peopleWalking: __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_PeopleWalkingRank_js__["a" /* PeopleWalkingRank */],
  possibleInjuries: __WEBPACK_IMPORTED_MODULE_8__vuex_modules_barCharts_PossibleInjuriesRank_js__["a" /* PossibleInjuriesRank */],
  propertyDamageOnly: __WEBPACK_IMPORTED_MODULE_9__vuex_modules_barCharts_PropertyDamageOnlyRank_js__["a" /* PropertyDamageOnlyRank */],
  seriousInjuries: __WEBPACK_IMPORTED_MODULE_10__vuex_modules_barCharts_SeriousInjuriesRank_js__["a" /* SeriousInjuriesRank */],
  speeding: __WEBPACK_IMPORTED_MODULE_11__vuex_modules_barCharts_SpeedingRank_js__["a" /* SpeedingRank */],
  totalCollisions: __WEBPACK_IMPORTED_MODULE_12__vuex_modules_barCharts_TotalCollisionsRank_js__["a" /* TotalCollisionsRank */],
  underTheInfluence: __WEBPACK_IMPORTED_MODULE_13__vuex_modules_barCharts_UnderTheInfluenceRank_js__["a" /* UnderTheInfluenceRank */]
};

var state = {
  resultsFilters: {}
};

var mutations = {
  SET_RESULTS_FILTERS: function SET_RESULTS_FILTERS(state, filters) {
    state.resultsFilters = filters;
  }
};

var actions = {
  fetchAll: function fetchAll(_ref, filters) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_RESULTS_FILTERS', filters);

    dispatch('costs/fetch', { slug: '/neighborhood/ranks/costs/economic/desc', filters: filters });
    dispatch('distractedDriving/fetch', { slug: '/neighborhood/ranks/who/inattentionind/desc', filters: filters });
    dispatch('fatalities/fetch', { slug: '/neighborhood/ranks/severity/5/desc', filters: filters });
    dispatch('injuries/fetch', { slug: '/neighborhood/ranks/severity/1/desc', filters: filters });
    dispatch('parkedCarsHit/fetch', { slug: '/neighborhood/ranks/who/hitparkedcar/desc', filters: filters });
    dispatch('peopleBiking/fetch', { slug: '/neighborhood/ranks/who/pedcylcount/desc', filters: filters });
    dispatch('peopleInvolved/fetch', { slug: '/neighborhood/ranks/who/personcount/desc', filters: filters });
    dispatch('peopleWalking/fetch', { slug: '/neighborhood/ranks/who/pedcount/desc', filters: filters });
    dispatch('possibleInjuries/fetch', { slug: '/neighborhood/ranks/severity/3/desc', filters: filters });
    dispatch('propertyDamageOnly/fetch', { slug: '/neighborhood/ranks/severity/2/desc', filters: filters });
    dispatch('seriousInjuries/fetch', { slug: '/neighborhood/ranks/severity/4/desc', filters: filters });
    dispatch('speeding/fetch', { slug: '/neighborhood/ranks/who/speeding/desc', filters: filters });
    dispatch('totalCollisions/fetch', { slug: '/neighborhood/ranks/totalcollisions/desc', filters: filters });
    dispatch('underTheInfluence/fetch', { slug: '/neighborhood/ranks/who/underinfl/desc', filters: filters });
  },

  setFilters: function setFilters(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    var startDate = typeof rootState.route.params.sd === 'undefined' ? '2006-01-01' : rootState.route.params.sd;

    dispatch('filterDateRange/setStartDate', startDate, { root: true });
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, { root: true });
  },

  resetResults: function resetResults(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('totalCollisions/reset');
    dispatch('costs/reset');
    dispatch('fatalities/reset');
    dispatch('seriousInjuries/reset');
    dispatch('injuries/reset');
    dispatch('propertyDamageOnly/reset');
    dispatch('possibleInjuries/reset');
    dispatch('peopleInvolved/reset');
    dispatch('peopleWalking/reset');
    dispatch('peopleBiking/reset');
    dispatch('parkedCarsHit/reset');
    dispatch('speeding/reset');
    dispatch('distractedDriving/reset');
    dispatch('underTheInfluence/reset');
  }
};

var getters = {
  filters: function filters(state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    };
  },


  resultsFilters: function resultsFilters(state) {
    return state.resultsFilters;
  }
};

var NeighborhoodRanksView = {
  namespaced: true,
  modules: modules,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NeighborhoodView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_modules_pageInfo_Info_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_AddressTypes_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_CollisionTypes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_DamageCosts_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_JunctionTypes_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_LightConditions_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_RoadConditions_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_Weather_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_modules_lineCharts_MonthlyCollisions_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_modules_tables_WhoRank_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_modules_tables_SeverityRank_js__ = __webpack_require__(80);
















var modules = {
  pageInfo: __WEBPACK_IMPORTED_MODULE_0__vuex_modules_pageInfo_Info_js__["a" /* Info */],
  addressTypes: __WEBPACK_IMPORTED_MODULE_1__vuex_modules_barCharts_AddressTypes_js__["a" /* AddressTypes */],
  collisionTypes: __WEBPACK_IMPORTED_MODULE_2__vuex_modules_barCharts_CollisionTypes_js__["a" /* CollisionTypes */],
  damageCosts: __WEBPACK_IMPORTED_MODULE_3__vuex_modules_barCharts_DamageCosts_js__["a" /* DamageCosts */],
  junctionTypes: __WEBPACK_IMPORTED_MODULE_4__vuex_modules_barCharts_JunctionTypes_js__["a" /* JunctionTypes */],
  lightConditions: __WEBPACK_IMPORTED_MODULE_5__vuex_modules_barCharts_LightConditions_js__["a" /* LightConditions */],
  roadConditions: __WEBPACK_IMPORTED_MODULE_6__vuex_modules_barCharts_RoadConditions_js__["a" /* RoadConditions */],
  weather: __WEBPACK_IMPORTED_MODULE_7__vuex_modules_barCharts_Weather_js__["a" /* Weather */],
  whoRank: __WEBPACK_IMPORTED_MODULE_9__vuex_modules_tables_WhoRank_js__["a" /* WhoRank */],
  severityRank: __WEBPACK_IMPORTED_MODULE_10__vuex_modules_tables_SeverityRank_js__["a" /* SeverityRank */],
  monthlyCollisions: __WEBPACK_IMPORTED_MODULE_8__vuex_modules_lineCharts_MonthlyCollisions_js__["a" /* MonthlyCollisions */]
};

var state = {
  resultsFilters: {}
};

var mutations = {
  SET_RESULTS_FILTERS: function SET_RESULTS_FILTERS(state, filters) {
    state.resultsFilters = filters;
  }
};

var actions = {
  fetchAll: function fetchAll(_ref, params) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_RESULTS_FILTERS', params.filters);
    dispatch('pageInfo/fetch', { slug: '/neighborhood/' + params.id + '/info', filters: params.filters });

    dispatch('addressTypes/fetch', { slug: '/neighborhood/' + params.id + '/address/types/', filters: params.filters });
    dispatch('collisionTypes/fetch', { slug: '/neighborhood/' + params.id + '/collision/types/', filters: params.filters });
    dispatch('damageCosts/fetch', { slug: '/neighborhood/' + params.id + '/costs/economic', filters: params.filters });
    dispatch('junctionTypes/fetch', { slug: '/neighborhood/' + params.id + '/junction/types/', filters: params.filters });
    dispatch('lightConditions/fetch', { slug: '/neighborhood/' + params.id + '/light/conditions/', filters: params.filters });
    dispatch('roadConditions/fetch', { slug: '/neighborhood/' + params.id + '/road/conditions/', filters: params.filters });
    dispatch('weather/fetch', { slug: '/neighborhood/' + params.id + '/weather', filters: params.filters });

    dispatch('whoRank/fetch', { slug: '/neighborhood/' + params.id + '/rankings/who', filters: params.filters });
    dispatch('severityRank/fetch', { slug: '/neighborhood/' + params.id + '/rankings/severity', filters: params.filters });
    dispatch('monthlyCollisions/fetch', { slug: '/neighborhood/' + params.id + '/monthlycollisions', filters: params.filters });
  },

  setFilters: function setFilters(_ref2) {
    var dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    var startDate = typeof rootState.route.params.sd === 'undefined' ? '2006-01-01' : rootState.route.params.sd;

    dispatch('filterDateRange/setStartDate', startDate, { root: true });
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, { root: true });
  },

  resetResults: function resetResults(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('pageInfo/reset');
    dispatch('addressTypes/reset');
    dispatch('collisionTypes/reset');
    dispatch('monthlyCollisions/reset');
    dispatch('junctionTypes/reset');
    dispatch('lightConditions/reset');
    dispatch('roadConditions/reset');
    dispatch('weather/reset');
    dispatch('whoRank/reset');
    dispatch('severityRank/reset');
    dispatch('damageCosts/reset');
  }
};

var getters = {
  filters: function filters(state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    };
  },


  resultsFilters: function resultsFilters(state) {
    return state.resultsFilters;
  }
};

var NeighborhoodView = {
  namespaced: true,
  modules: modules,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NeighborhoodsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);



var startState = [];

var state = {
  neighborhoods: startState
};

var mutations = {
  FETCH: function FETCH(state) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["b" /* makeApiUrl */]('/neighborhood/all')).then(function (response) {
      state.neighborhoods = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  RESET: function RESET(state) {
    state.neighborhoods = startState;
  }
};

var actions = {
  fetch: function fetch(_ref, filters) {
    var commit = _ref.commit;

    commit('FETCH', filters);
  },

  reset: function reset(_ref2) {
    var commit = _ref2.commit;

    commit('RESET');
  }
};

var getters = {
  get: function get(state) {
    return state.neighborhoods;
  }
};

var NeighborhoodsView = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoogleAnalytics__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoogleAnalytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GoogleAnalytics__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'Sidebar': __WEBPACK_IMPORTED_MODULE_0__components_Sidebar___default.a,
    'GoogleAnalytics': __WEBPACK_IMPORTED_MODULE_1__components_GoogleAnalytics___default.a
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilterDatePreset__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilterDatePreset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FilterDatePreset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterDateRange__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterDateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FilterDateRange__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filterDate',

  props: {
    'defaultOption': {
      type: Object,
      required: false
    }
  },

  data: function data() {
    return {
      dateToggleLabel: 'Custom date range'
    };
  },

  components: {
    'FilterDatePreset': __WEBPACK_IMPORTED_MODULE_0__components_FilterDatePreset___default.a,
    'FilterDateRange': __WEBPACK_IMPORTED_MODULE_1__components_FilterDateRange___default.a
  },

  methods: {
    toggleDateFilter: function toggleDateFilter() {
      var wellContent = document.getElementById('filterdate');
      wellContent.classList.toggle('s-date-toggled');

      if (this.dateToggleLabel === 'Preset date range') {
        this.dateToggleLabel = 'Custom date range';
      } else {
        this.dateToggleLabel = 'Preset date range';
      }
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filterDatePreset',
  props: {
    'cssClass': {
      type: String,
      required: false,
      default: ''
    },
    'defaultOption': {
      type: Object,
      required: false
    }
  },

  data: function data() {
    return {
      selection: this.defaultOption,
      options: [this.defaultOption, { key: '2023', label: '2023' }, { key: '2022', label: '2022' }, { key: '2021', label: '2021' }, { key: '2020', label: '2020' }, { key: '2019', label: '2019' }, { key: '2018', label: '2018' }, { key: '2017', label: '2017' }, { key: '2016', label: '2016' }, { key: '2015', label: '2015' }, { key: '2014', label: '2014' }, { key: '2013', label: '2013' }, { key: '2012', label: '2012' }, { key: '2011', label: '2011' }, { key: '2010', label: '2010' }, { key: '2009', label: '2009' }, { key: '2008', label: '2008' }, { key: '2007', label: '2007' }, { key: '2006', label: '2006' }, { key: 'all', label: 'All (2006 - 2023)' }]
    };
  },

  components: {
    'Multiselect': __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },

  methods: {
    setDateRange: function setDateRange(value) {
      var startDate = '';
      var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();

      if (value.key === 'all') {
        startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()('2006-01-01');
        endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()('2023-06-01');
      } else if (value.key === '2023') {
        startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value.key + '-01-01');
        endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value.key + '-06-01');
      } else {
        startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value.key + '-01-01');
        endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value.key + '-12-31');
      }

      this.selection = { key: value.key, label: value.label };
      this.$store.dispatch('filterDateRange/setStartDate', startDate.format('YYYY-MM-DD'));
      this.$store.dispatch('filterDateRange/setEndDate', endDate.format('YYYY-MM-DD'));
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filterDateRange',

  props: {
    'label': '',
    'cssClass': ''
  },

  data: function data() {
    return {
      startDatePicker: {},
      endDatePicker: {}
    };
  },

  mounted: function mounted() {
    this.startDatePicker = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
      field: document.getElementById('start_date_picker'),
      format: 'MM/DD/YYYY',
      minDate: new Date(2006, 0, 1),
      maxDate: new Date(2023, 5, 1),
      defaultDate: this.startDate,
      setDefaultDate: true,
      trigger: document.getElementById('startdatepickertrigger')
    });

    this.endDatePicker = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
      field: document.getElementById('end_date_picker'),
      format: 'MM/DD/YYYY',
      minDate: new Date(2006, 0, 1),
      maxDate: new Date(2023, 5, 1),
      defaultDate: this.endDate,
      setDefaultDate: true,
      trigger: document.getElementById('enddatepickertrigger')
    });
  },

  computed: {
    isValidEndDate: function isValidEndDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endDate).isBefore(this.startDate) ? 0 : 1;
    },
    startDate: function startDate() {
      if (this.$route.params.sd) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$route.params.sd, 'YYYY-MM-DD').toDate();
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters['filterDateRange/startDate'], 'YYYY-MM-DD').toDate();
    },
    endDate: function endDate() {
      if (this.$route.params.ed) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$route.params.ed, 'YYYY-MM-DD').toDate();
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters['filterDateRange/endDate'], 'YYYY-MM-DD').toDate();
    }
  },

  methods: {
    setStartDate: function setStartDate() {
      if (typeof this.startDatePicker.getMoment !== 'undefined') {
        this.$store.dispatch('filterDateRange/setStartDate', this.startDatePicker.getMoment().format('YYYY-MM-DD'));
      }
    },
    setEndDate: function setEndDate() {
      if (typeof this.endDatePicker.getMoment !== 'undefined') {
        this.$store.dispatch('filterDateRange/setEndDate', this.endDatePicker.getMoment().format('YYYY-MM-DD'));
      }
    }
  },

  watch: {
    startDate: function startDate() {
      this.startDatePicker.setDate(this.startDate);
    },

    endDate: function endDate() {
      this.endDatePicker.setDate(this.endDate);
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filterLocations',

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },

  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    results: function results() {
      return this.$store.getters['filterLocations/results'];
    },
    resultsLocations: function resultsLocations() {
      return this.$store.getters['filterLocations/selectedLocations'];
    },
    isLoading: function isLoading() {}
  },

  watch: {
    $route: function $route(to, from) {
      if (this.$route.params.lids) {
        this.$store.dispatch('filterLocations/setSelectedLocations', this.$route.params.lids);
      }
    }
  },

  methods: {
    limitText: function limitText(count) {
      return 'and ' + count + ' other locations';
    },


    search: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (formInput) {
      this.$store.dispatch('filterLocations/search', formInput);
    }),

    goTo: function goTo() {
      this.$router.push({
        name: 'locations',
        params: {
          lids: this.$store.getters['filterLocations/selectedLocationIds'].toString()
        }
      });
    },
    addSelectedLocationId: function addSelectedLocationId(selectedLocation) {
      this.$store.dispatch('filterLocations/addSelectedLocationId', selectedLocation.id);
    },
    removeSelectedLocationId: function removeSelectedLocationId(removedLocation) {
      this.$store.dispatch('filterLocations/removeSelectedLocationId', removedLocation.id);
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filterMapActive',

  methods: {
    set: function set(e) {
      this.$store.dispatch('filterMapActive/set', +e.target.checked);
    }
  },

  computed: {
    get: function get() {
      return this.$store.getters['filterMapActive/get'];
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filterSubmitButton',

  props: ['routeName', 'routeParams'],

  methods: {
    goTo: function goTo() {
      this.$router.push({
        name: this.routeName,
        params: this.routeParams
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoaderDots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);






__webpack_require__(419);
__webpack_require__(418);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'geo',

  components: {
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_0__components_LoaderDots___default.a
  },

  props: {
    'mapData': {
      type: Array,
      required: false
    },
    'multipolygons': {
      type: Array,
      required: false
    },
    'markerClickAction': {
      type: String,
      required: false
    },
    'mapActive': {
      type: Number,
      required: false
    },
    'polygons': {
      type: Array,
      required: false
    }
  },

  data: function data() {
    return {
      currentMarker: null,
      theMap: {},
      drawnItems: false,
      drawControls: {},
      mapDataLayerGroup: new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.LayerGroup(),
      multipolygonFeatureGroup: new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.FeatureGroup(),
      polygonFeatureGroup: new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.FeatureGroup(),
      mapSizes: ['s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full'],
      currentMapSize: 's-map-default'
    };
  },

  mounted: function mounted() {
    this.setMap();
    var app = document.getElementById('app');
    app.classList.add('s-map-default');
  },

  computed: {
    isLoading: function isLoading() {
      if (typeof this.mapData !== 'undefined') {
        return this.mapData.length === 0 ? 1 : 0;
      }

      if (typeof this.multipolygons !== 'undefined') {
        return this.multipolygons.length === 0 ? 1 : 0;
      }

      if (typeof this.polygons !== 'undefined') {
        return this.polygons.length === 0 ? 1 : 0;
      }
    },
    hasResults: function hasResults() {
      if (typeof this.mapData !== 'undefined') {
        return this.mapData[0] === -1 ? 0 : 1;
      }

      if (typeof this.multipolygons !== 'undefined') {
        return this.multipolygons.length === 0 ? 0 : 1;
      }

      if (typeof this.polygons !== 'undefined') {
        return this.polygons.length === 0 ? 0 : 1;
      }
    }
  },

  watch: {
    mapActive: function mapActive() {
      if (this.mapActive === 1) {
        this.activateDrawing();
      } else {
        this.deactivateDrawing();
      }
    },

    mapData: function mapData() {
      if (this.hasResults) {
        this.refreshMapDataLayerGroup();
      }
    },

    multipolygons: function multipolygons() {
      if (this.hasResults) {
        this.refreshMultipolygonFeatureGroup();
      }
    },

    polygons: function polygons() {
      if (this.hasResults) {
        this.refreshPolygonFeatureGroup();
      }
    }
  },

  methods: {
    activateDrawing: function activateDrawing() {
      var _this = this;

      if (this.drawnItems) {
        this.theMap.addLayer(this.drawnItems);
      } else {
        this.drawnItems = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.featureGroup().addTo(this.theMap);
      }

      this.drawControls = new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Control.Draw({
        draw: {
          polyline: false,
          rectangle: false,
          marker: false,
          circlemarker: false,
          circle: {
            allowIntersection: false,
            shapeOptions: {
              color: '#EF780E',
              opacity: 0.75
            },
            showArea: true
          },
          polygon: {
            allowIntersection: false,
            shapeOptions: {
              color: '#EF780E',
              opacity: 0.75
            },
            showArea: true
          }
        },
        edit: { featureGroup: this.drawnItems },
        position: 'topleft'
      });

      this.theMap.addControl(this.drawControls);

      this.theMap.on(__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Draw.Event.CREATED, function (event) {
        _this.drawnItems.addLayer(event.layer);
      });
    },
    deactivateDrawing: function deactivateDrawing() {
      this.theMap.removeControl(this.drawControls);
      this.theMap.removeLayer(this.drawnItems);
    },
    adjustMapSize: function adjustMapSize(direction) {
      var app = document.getElementById('app');
      this.mapSizes.forEach(function (mapSize) {
        if (app.classList.contains(mapSize)) {
          app.classList.remove(mapSize);
        }
      });

      var currentMapSize = this.currentMapSize;
      var mapSizeIndex = this.mapSizes.findIndex(function (mapSize) {
        return currentMapSize === mapSize;
      });

      if (direction === 'grow') {
        mapSizeIndex += 1;
      } else {
        mapSizeIndex -= 1;
      }

      this.currentMapSize = this.mapSizes[mapSizeIndex];
      app.classList.add(this.currentMapSize);

      this.theMap.invalidateSize();
    },
    refreshMapDataLayerGroup: function refreshMapDataLayerGroup() {
      this.theMap.removeLayer(this.mapDataLayerGroup);
      this.setMapDataLayerGroup();
      this.theMap.addLayer(this.mapDataLayerGroup);
      this.setView();
    },
    refreshMultipolygonFeatureGroup: function refreshMultipolygonFeatureGroup() {
      this.theMap.removeLayer(this.multipolygonFeatureGroup);
      this.setMultipolygonFeatureGroup(this.multipolygons);
      this.theMap.addLayer(this.multipolygonFeatureGroup);
      this.theMap.fitBounds(this.multipolygonFeatureGroup.getBounds());
    },
    refreshPolygonFeatureGroup: function refreshPolygonFeatureGroup() {
      this.theMap.removeLayer(this.polygonFeatureGroup);
      this.setPolygonFeatureGroup();
      this.theMap.addLayer(this.polygonFeatureGroup);
      this.theMap.fitBounds(this.polygonFeatureGroup.getBounds());
    },
    setMap: function setMap() {
      if (this.theMap) {
        var vm = this;

        this.theMap = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.map(document.getElementById('map'), {
          zoomControl: false,
          scrollWheelZoom: false,
          minZoom: 11,
          maxBounds: __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.latLngBounds(__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.latLng(50, -120), __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.latLng(46, -125)) }).setView([47.6062, -122.3321], 12).on('moveend', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
          var mapBounds = {
            ne: { lat: vm.theMap.getBounds()._northEast.lat, lng: vm.theMap.getBounds()._northEast.lng },
            sw: { lat: vm.theMap.getBounds()._southWest.lat, lng: vm.theMap.getBounds()._southWest.lng }
          };
          vm.$store.dispatch('filterMapBounds/set', mapBounds);
        }, 500));

        var zoomControl = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.control.zoom({ position: 'topleft' });
        this.theMap.addControl(zoomControl);

        __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer('http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
        }).addTo(this.theMap);

        __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Icon.Default.prototype.options.imagePath = '/static/';
      }
    },
    setMapDataLayerGroup: function setMapDataLayerGroup() {
      var _this2 = this;

      var markers = [];

      this.mapData.forEach(function (row) {
        var vm = _this2;

        markers.push(__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.marker([row.lat, row.lng], {
          title: row.id
        }).on('click', function (e) {
          if (vm.currentMarker !== null) {
            vm.currentMarker.setIcon(__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
              iconUrl: '/static/marker-icon.png',
              iconRetinaUrl: '/static/marker-icon-2x.png'
            }));
          }

          vm.currentMarker = this.setIcon(__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
            iconUrl: '/static/marker-icon-yellow.png',
            iconRetinaUrl: '/static/marker-icon-2x-yellow.png'
          }));

          vm.theMap.panTo(this.getLatLng());
          vm.$store.dispatch(vm.markerClickAction, this.options.title);
        }));
      });

      this.mapDataLayerGroup = new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.LayerGroup().addLayer(__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.markerClusterGroup().addLayers(markers));
    },
    setMultipolygonFeatureGroup: function setMultipolygonFeatureGroup() {
      var _this3 = this;

      this.setShapeFeatureGroup(this.multipolygons).forEach(function (layer) {
        _this3.multipolygonFeatureGroup.addLayer(layer);
      });
    },
    setPolygonFeatureGroup: function setPolygonFeatureGroup() {
      var _this4 = this;

      this.setShapeFeatureGroup(this.polygons).forEach(function (layer) {
        _this4.polygonFeatureGroup.addLayer(layer);
      });
    },
    setShapeFeatureGroup: function setShapeFeatureGroup(shapes) {
      var layers = [];

      shapes.forEach(function (shape) {
        var layer = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.polygon(shape.data, shape.options);

        if (shape.hasOwnProperty('click')) {
          layer.on('click', shape.click);
        }

        if (shape.hasOwnProperty('mouseover')) {
          layer.on('mouseover', shape.mouseover);
        }

        if (shape.hasOwnProperty('mouseout')) {
          layer.on('mouseout', shape.mouseout);
        }

        if (shape.hasOwnProperty('tooltip')) {
          layer.bindTooltip(shape.tooltip);
        }

        layers.push(layer);
      });

      return layers;
    },
    setView: function setView() {
      this.theMap.setView([47.6062, -122.3321], 11);
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {



if (true) {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

  ga('create', 'UA-301228-6', 'auto');
  ga('send', 'pageview');
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoaderDots__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lineChart',

  components: {
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_2__components_LoaderDots___default.a
  },

  props: {
    'chartData': {},
    'chartDataLabelX': '',
    'chartDataLabelY': '',
    'additionalDatasets': '',
    'legend': '',
    'labelPrefix': '',
    'lineColor': '',
    'borderWidth': '',
    'backgroundColor': '',
    'pointBackgroundColor': '',
    'pointBorderColor': ''
  },

  data: function data() {
    return {
      chartid: 'line' + this._uid
    };
  },

  computed: {
    hasResults: function hasResults() {
      return this.chartData.length === -1 ? 0 : 1;
    },
    isLoading: function isLoading() {
      return this.lineChartAmounts.length === 0 ? 1 : 0;
    },
    noDataAvailable: function noDataAvailable() {
      if (this.hasResults) {
        return this.chartData.filter(function (series) {
          return series.title === 'No data available';
        })[0];
      }

      return [];
    },
    lineChartAmounts: function lineChartAmounts() {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) {
          return data.amount;
        });
      }

      return [];
    },
    lineChartLabels: function lineChartLabels() {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) {
          return data.title;
        });
      }

      return [];
    },
    chartDataWithoutNullValues: function chartDataWithoutNullValues() {
      if (this.hasResults) {
        return this.chartData.filter(function (series) {
          return series.title !== 'No data available';
        });
      }

      return [];
    },
    prefix: function prefix() {
      return this.labelPrefix ? this.labelPrefix : ' ';
    }
  },

  watch: {
    chartData: function chartData() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.theChart) === 'object') {
        this.theChart.destroy();
      }

      var vm = this;
      var data = {
        labels: vm.lineChartLabels,
        datasets: [{
          borderColor: vm.lineColor,
          borderWidth: vm.borderWidth,
          backgroundColor: vm.backgroundColor,
          pointBorderColor: vm.pointBorderColor,
          pointColor: vm.pointColor,
          data: vm.lineChartAmounts
        }]
      };

      if (vm.additionalDatasets.length > 0) {
        vm.additionalDatasets.forEach(function (dataset) {
          data.datasets.unshift(dataset);
        });
      }

      if (vm.lineChartAmounts.length > 0) {
        vm.theChart = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(document.getElementById(vm.chartid), {
          type: 'line',
          data: data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: vm.chartDataLabelX
                },
                ticks: {
                  maxTicksLimit: 16
                }
              }],
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: vm.chartDataLabelY
                },
                ticks: {
                  callback: function callback(value, index, values) {
                    if (value.toString().length < 8) {
                      return vm.prefix + Number(value).toLocaleString('en-US');
                    }

                    return vm.prefix + Number(Math.round(value / 1000000)).toLocaleString('en-US') + 'mil';
                  }
                }
              }]
            },

            tooltips: {
              callbacks: {
                beforeLabel: function beforeLabel(tooltipItem, data) {
                  return ' ' + vm.lineChartLabels[tooltipItem.index];
                },
                label: function label(tooltipItem, data) {
                  return vm.prefix + Number(vm.lineChartAmounts[tooltipItem.index]).toLocaleString('en-US');
                }
              }
            },

            legend: {
              display: false
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoaderDots'
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  methods: {
    toggle: function toggle(event) {
      var app = document.getElementById('app');
      if (window.innerWidth > 960) {
        app.classList.remove('s-sidebar-toggled');
      } else {
        app.classList.add('s-sidebar-toggled');
      }

      var navToggles = document.getElementsByClassName('nav-toggle');

      for (var key in navToggles) {
        if (typeof navToggles[key].classList !== 'undefined') {
          if (event.target === navToggles[key]) {
            event.target.parentElement.classList.toggle('active');
          } else if (event.target.parentElement === navToggles[key]) {
            event.target.parentElement.parentElement.classList.toggle('active');
          } else {
            navToggles[key].parentElement.classList.remove('active');
          }
        }
      }
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'seattleCityCouncilInformation'
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_about_Contact__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_about_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_about_Contact__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',

  components: {
    'Navigation': __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    'Contact': __WEBPACK_IMPORTED_MODULE_1__components_about_Contact___default.a
  },

  methods: {
    toggleSidebar: function toggleSidebar(event) {
      var app = document.getElementById('app');
      app.classList.toggle('s-sidebar-toggled');

      var navToggles = document.getElementsByClassName('nav-toggle');

      for (var key in navToggles) {
        if (typeof navToggles[key].classList !== 'undefined') {
          navToggles[key].parentElement.classList.remove('active');
        }
      }
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  methods: {
    openSidebar: function openSidebar(event) {
      var app = document.getElementById('app');

      if (app.classList.contains('s-sidebar-toggled') && window.innerWidth > 960) {
        app.classList.remove('s-sidebar-toggled');
      } else if (!app.classList.contains('s-sidebar-toggled') && window.innerWidth < 960) {
        app.classList.add('s-sidebar-toggled');
      }
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoaderBars__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoaderBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoaderBars__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BarChart',

  components: {
    'LoaderBars': __WEBPACK_IMPORTED_MODULE_2__components_LoaderBars___default.a
  },

  props: {
    'barColor': {
      type: String,
      required: false
    },
    'chartData': {
      type: Array,
      required: true
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'horizontalBar'
    },
    'labelPrefix': {
      type: String,
      required: false
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: true
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  data: function data() {
    return {
      chartid: 'bar' + this._uid
    };
  },

  computed: {
    isLoading: function isLoading() {
      if (Array.isArray(this.chartData)) {
        if (this.chartData[0] === -1) {
          return 0;
        }
      }

      return this.barChartAmounts.length === 0 ? 1 : 0;
    },
    hasResults: function hasResults() {
      if (Array.isArray(this.chartData)) {
        return this.chartData[0] === -1 ? 0 : 1;
      }

      return 0;
    },
    noDataAvailable: function noDataAvailable() {
      if (this.hasResults) {
        return this.chartData.filter(function (series) {
          return series.title === 'No data available';
        })[0];
      }

      return [];
    },
    barChartAmounts: function barChartAmounts() {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) {
          return data.amount;
        });
      }

      return [];
    },
    barChartLabels: function barChartLabels() {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) {
          return data.title;
        });
      }

      return [];
    },
    barChartIds: function barChartIds() {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) {
          if (typeof data.slug !== 'undefined') {
            return data.slug;
          }

          return data.id;
        });
      }

      return [];
    },
    chartBarColor: function chartBarColor() {
      return this.barColor;
    },
    chartLegendLink: function chartLegendLink() {
      return this.legendLink;
    },
    chartDataWithoutNullValues: function chartDataWithoutNullValues() {
      if (this.hasResults) {
        return this.chartData.filter(function (series) {
          return series.title !== 'No data available';
        });
      }

      return [];
    },
    prefix: function prefix() {
      return this.labelPrefix ? this.labelPrefix : ' ';
    }
  },

  watch: {
    chartData: function chartData() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.theChart) === 'object') {
        this.theChart.destroy();
      }

      var vm = this;
      var data = {
        labels: vm.barChartLabels,
        datasets: [{
          backgroundColor: vm.chartBarColor,
          data: vm.barChartAmounts
        }]
      };

      if (vm.barChartAmounts.length > 0) {
        vm.theChart = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(document.getElementById(vm.chartid), {
          type: vm.chartType,
          data: data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [{
                stacked: vm.stacked,
                ticks: {
                  maxRotation: vm.xMaxAxesRotation,
                  minRotation: vm.xMinAxesRotation,
                  beginAtZero: true,
                  autoSkip: false,
                  callback: function callback(value, index, values) {
                    if (vm.chartType === 'horizontalBar') {
                      if (value.toString().length < 8) {
                        return vm.prefix + Number(value).toLocaleString('en-US');
                      }

                      return vm.prefix + Number(Math.round(value / 1000000)).toLocaleString('en-US') + 'mil';
                    }

                    return value;
                  }
                }
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  callback: function callback(value, index, values) {
                    if (vm.chartType === 'bar') {
                      if (parseInt(value).toString().length < 8) {
                        return vm.prefix + Number(value).toLocaleString('en-US');
                      }

                      return vm.prefix + Number(Math.round(value / 1000000)).toLocaleString('en-US') + 'mil';
                    }

                    return value;
                  }
                }
              }]
            },

            tooltips: {
              callbacks: {
                label: function label(tooltipItem, data) {
                  return vm.prefix + Number(vm.barChartAmounts[tooltipItem.index]).toLocaleString('en-US');
                }
              }
            },

            legend: {
              display: false
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'barChartWithTable',

  props: {
    'cardColor': {
      type: String,
      required: false
    },
    'cardIcon': {
      type: String,
      required: false
    },
    'getter': {
      type: String,
      required: true
    },
    'tableColor': {
      type: String,
      required: false
    },
    'title': {
      type: String,
      required: false
    },

    'barColor': {
      type: String,
      required: false
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'bar'
    },
    'labelPrefix': {
      type: String,
      required: false
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: false
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  components: {
    'BarChart': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default.a
  },

  computed: {
    json: function json() {
      return this.$store.getters[this.getter];
    },
    chartData: function chartData() {
      if (this.json.amounts) {
        return this.json.amounts.filter(function (series) {
          return series.title !== 'No data available';
        });
      }

      return [];
    },
    noDataAvailable: function noDataAvailable() {
      if (this.json.amounts) {
        return this.json.amounts.filter(function (series) {
          return series.title === 'No data available';
        })[0];
      }
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'damageCosts',

  props: {
    'cardColor': {
      type: String,
      required: false,
      default: 'green'
    },
    'cardIcon': {
      type: String,
      required: false,
      default: 'attach_money'
    },
    'getter': {
      type: String,
      required: true
    },
    'tableColor': {
      type: String,
      required: false,
      default: 'green'
    },
    'title': {
      type: String,
      required: false
    },

    'barColor': {
      type: String,
      required: false
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'bar'
    },
    'labelPrefix': {
      type: String,
      required: false,
      default: ' $'
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: false
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  components: {
    'BarChart': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default.a
  },

  computed: {
    chartData: function chartData() {
      return this.$store.getters[this.getter].amounts ? this.$store.getters[this.getter].amounts : [];
    },
    tableData: function tableData() {
      return this.$store.getters[this.getter];
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ranks',

  props: {
    'cardColor': {
      type: String,
      required: false
    },
    'cardIcon': {
      type: String,
      required: false
    },
    'fullListToggleDispatch': {
      type: String,
      required: false
    },
    'fullListOptionsDispatch': {
      type: String,
      required: false
    },
    'fullListOptions': {
      type: Object,
      required: false
    },
    'getter': {
      type: String,
      required: true
    },
    'title': {
      type: String,
      required: false
    },

    'barColor': {
      type: String,
      required: false
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'horizontalBar'
    },
    'labelPrefix': {
      type: String,
      required: false
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: true
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  components: {
    'BarChart': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default.a
  },

  computed: {
    chartData: function chartData() {
      return this.$store.getters[this.getter];
    },
    hasResults: function hasResults() {
      return this.chartData[0] === -1 ? 0 : 1;
    }
  },

  methods: {
    loadFullList: function loadFullList() {
      this.$store.dispatch(this.fullListToggleDispatch);
      this.$store.dispatch(this.fullListOptionsDispatch, this.fullListOptions);
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LineChart__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LineChart__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'monthlyCollisions',

  components: {
    'LineChart': __WEBPACK_IMPORTED_MODULE_0__components_LineChart___default.a
  },

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  computed: {
    additionalDatasets: function additionalDatasets() {
      var vm = this;
      return [{
        pointRadius: 0,
        pointHoverRadius: 0,
        borderDash: [10, 10],
        borderWidth: 2,
        borderColor: vm.$store.getters.brown.light.a,
        backgroundColor: 'transparent',
        data: this.monthlyCollisions.map(function () {
          return vm.average;
        })
      }];
    },
    average: function average() {
      return this.$store.getters[this.getters.average];
    },
    monthlyCollisions: function monthlyCollisions() {
      return this.$store.getters[this.getters.monthlyCollisions] ? this.$store.getters[this.getters.monthlyCollisions] : [];
    },
    total: function total() {
      return this.$store.getters[this.getters.total];
    },
    legend: function legend() {
      return [{ label: 'Total collisions = ' + Number(this.total).toLocaleString('en-US') }, { label: 'Average = ' + Number(this.average).toLocaleString('en-US') + ' per month' }];
    },
    lineColor: function lineColor() {
      return this.$store.getters.yellow.default;
    },
    backgroundColor: function backgroundColor() {
      return this.$store.getters.yellow.light.c;
    },
    pointBackgroundColor: function pointBackgroundColor() {
      return this.$store.getters.yellow.light.a;
    },
    pointBorderColor: function pointBorderColor() {
      return this.$store.getters.yellow.light.a;
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__);





var labels = {
  fatalities: {
    plural: 'Collisions with fatalities'
  },
  injuries: {
    plural: 'Collisions with injuries'
  },
  propertydamage: {
    plural: 'Property damage only collisions'
  },
  possibleinjury: {
    plural: 'Collisions with possible injuries'
  },
  seriousinjuries: {
    plural: 'Collisions with serious injuries'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'severityRank',

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  components: {
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default.a
  },

  data: function data() {
    return {
      labels: labels
    };
  },

  computed: {
    hasResults: function hasResults() {
      return this.rankings[0] === -1 ? 0 : 1;
    },
    isLoading: function isLoading() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.rankings).length === 0 ? 1 : 0;
    },
    rankings: function rankings() {
      return this.$store.getters[this.getters.rankings];
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__);





var labels = {
  cyclists: {
    icon: 'directions_bike',
    plural: 'Cyclists involved'
  },
  hitparkedcar: {
    icon: 'local_parking',
    plural: 'Parked cars hit'
  },
  inattention: {
    icon: 'visibility_off',
    plural: 'Cases due to inattention'
  },
  pedestrians: {
    icon: 'directions_walk',
    plural: 'Pedestrians'
  },
  people: {
    icon: 'person',
    plural: 'People involved'
  },
  speeding: {
    icon: 'fast_forward',
    plural: 'Cases of speeding'
  },
  underinfl: {
    icon: 'blur_on',
    plural: 'Cases of driving under the influence'
  },
  vehicles: {
    icon: 'directions_car',
    plural: 'Vehicles involved'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'whoRank',

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  components: {
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default.a
  },

  data: function data() {
    return {
      labels: labels
    };
  },

  computed: {
    hasResults: function hasResults() {
      return this.rankings[0] === -1 ? 0 : 1;
    },
    isLoading: function isLoading() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.rankings).length === 0 ? 1 : 0;
    },
    rankings: function rankings() {
      return this.$store.getters[this.getters.rankings];
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fullList',

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  mounted: function mounted() {
    if (this.isActive) {
      this.$store.dispatch(this.getters.toggleActive);
    }

    this.$store.dispatch(this.getters.reset);
  },

  components: {
    'BarChart': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChart___default.a,
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default.a
  },

  computed: {
    options: function options() {
      return this.$store.getters[this.getters.options];
    },
    filters: function filters() {
      var filters = this.$store.getters[this.getters.filters];
      filters.params = this.getters.filterParams;

      return filters;
    },
    fullList: function fullList() {
      return this.$store.getters[this.getters.get];
    },
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.$store.getters[this.getters.filters].startDate).format('MMMM Do YYYY');
    },
    endDate: function endDate() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.$store.getters[this.getters.filters].endDate).format('MMMM Do YYYY');
    },
    isActive: function isActive() {
      return this.$store.getters[this.getters.active];
    },
    isLoading: function isLoading() {
      return this.fullList.length > 0 ? 0 : 1;
    }
  },

  methods: {
    closeList: function closeList() {
      this.$store.dispatch(this.getters.toggleActive);
      this.$store.dispatch(this.getters.reset);
    }
  },

  watch: {
    isActive: function isActive() {
      if (this.isActive) {
        this.$store.dispatch(this.getters.fetch, { slug: this.options.apiSlug, filters: this.filters });
      }
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SeattleCityCouncilInformation__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SeattleCityCouncilInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SeattleCityCouncilInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_barCharts_DamageCosts__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_barCharts_DamageCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_barCharts_DamageCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tables_SeverityRank__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tables_SeverityRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tables_SeverityRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tables_WhoRank__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tables_WhoRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tables_WhoRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lineCharts_MonthlyCollisions__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lineCharts_MonthlyCollisions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_lineCharts_MonthlyCollisions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Geo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Geo__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cityCouncilDistrict',

  components: {
    'SeattleCityCouncilInformation': __WEBPACK_IMPORTED_MODULE_0__components_SeattleCityCouncilInformation___default.a,
    'AddressTypes': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default.a,
    'JunctionTypes': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default.a,
    'CollisionTypes': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default.a,
    'LightConditions': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default.a,
    'RoadConditions': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default.a,
    'Weather': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_BarChartWithTable___default.a,
    'DamageCosts': __WEBPACK_IMPORTED_MODULE_2__components_barCharts_DamageCosts___default.a,
    'MonthlyCollisions': __WEBPACK_IMPORTED_MODULE_5__components_lineCharts_MonthlyCollisions___default.a,
    'Geo': __WEBPACK_IMPORTED_MODULE_6__components_Geo___default.a,
    'SeverityRank': __WEBPACK_IMPORTED_MODULE_3__components_tables_SeverityRank___default.a,
    'WhoRank': __WEBPACK_IMPORTED_MODULE_4__components_tables_WhoRank___default.a
  },

  computed: {
    filters: function filters() {
      return this.$store.getters['cityCouncilDistrictView/filters'];
    },
    districtInfo: function districtInfo() {
      return this.$store.getters['cityCouncilDistrictView/pageInfo/get'];
    },
    polygons: function polygons() {
      if (typeof this.districtInfo.polygon !== 'undefined') {
        return [{
          data: [this.districtInfo.polygon],
          options: {
            color: this.$store.getters.teal.dark.a,
            interactive: false
          }
        }];
      }
    }
  },

  mounted: function mounted() {
    this.$store.dispatch('cityCouncilDistrictView/resetResults');
    this.$store.dispatch('cityCouncilDistrictView/setFilters');
    this.$store.dispatch('cityCouncilDistrictView/fetchAll', { id: this.$store.state.route.params.id, filters: this.filters });
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('cityCouncilDistrictView/resetResults');
      this.$store.dispatch('cityCouncilDistrictView/fetchAll', { id: this.$store.state.route.params.id, filters: this.filters });
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full');
    next();
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterDate__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FilterDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_trays_FullList__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_trays_FullList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_trays_FullList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cityCouncilDistrictRanks',

  data: function data() {
    return {
      dateToggleLabel: 'Custom date range'
    };
  },

  components: {
    'FilterDate': __WEBPACK_IMPORTED_MODULE_1__components_FilterDate___default.a,
    'FilterSubmitButton': __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton___default.a,
    'SeattleCityCouncilInformation': __WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation___default.a,
    'Costs': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'TotalCollisions': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'Fatalities': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'SeriousInjuries': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'Injuries': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PossibleInjuries': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PeopleInvolved': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PeopleWalking': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PeopleBiking': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'DistractedDriving': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'UnderTheInfluence': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PropertyDamageOnly': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'ParkedCarsHit': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'Speeding': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'FullList': __WEBPACK_IMPORTED_MODULE_4__components_trays_FullList___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('cityCouncilDistrictRanksView/resetResults');
    this.$store.dispatch('cityCouncilDistrictRanksView/setFilters');
    this.$store.dispatch('cityCouncilDistrictRanksView/fetchAll', this.filters);
    document.getElementById('app').classList.add('city-council-district-ranks');
  },

  computed: {
    filters: function filters() {
      return this.$store.getters['cityCouncilDistrictRanksView/filters'];
    },
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.resultsFilters.startDate).format('MMMM Do, YYYY');
    },
    endDate: function endDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.resultsFilters.endDate).format('MMMM Do, YYYY');
    },
    routeParams: function routeParams() {
      return { sd: this.filters.startDate, ed: this.filters.endDate };
    },
    resultsFilters: function resultsFilters() {
      return this.$store.getters['cityCouncilDistrictRanksView/resultsFilters'];
    },
    isLoading: function isLoading() {
      return this.$store.getters['cityCouncilDistrictRanksView/costs/get'].length > 0 ? 0 : 1;
    },
    fullListActive: function fullListActive() {
      return this.$store.getters['cityCouncilDistrictRanksView/fullList/active'];
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('cityCouncilDistrictRanksView/resetResults');
      this.$store.dispatch('cityCouncilDistrictRanksView/setFilters');
      this.$store.dispatch('cityCouncilDistrictRanksView/fetchAll', this.filters);
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'cityCouncilDistrictRanks') {
      document.getElementById('app').classList.remove('city-council-district-ranks');
    }
    next();
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Geo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Geo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SeattleCityCouncilInformation__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SeattleCityCouncilInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SeattleCityCouncilInformation__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cityCouncilDistricts',

  components: {
    'Geo': __WEBPACK_IMPORTED_MODULE_0__components_Geo___default.a,
    'SeattleCityCouncilInformation': __WEBPACK_IMPORTED_MODULE_1__components_SeattleCityCouncilInformation___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('cityCouncilDistrictsView/reset');
    this.$store.dispatch('cityCouncilDistrictsView/fetch');
  },

  computed: {
    districts: function districts() {
      return this.$store.getters['cityCouncilDistrictsView/get'];
    },
    polygons: function polygons() {
      var polygons = [];
      var vm = this;
      var defaultColor = vm.$store.getters.teal.dark.a;

      this.districts.forEach(function (district) {
        polygons.push({
          data: district.polygon,
          options: {
            color: defaultColor,
            weight: 2
          },
          click: function click(e) {
            vm.$router.push({ name: 'cityCouncilDistrict', params: { id: district.id } });
          },
          mouseover: function mouseover(e) {
            this.setStyle({ color: vm.$store.getters.orange.default });
          },
          mouseout: function mouseout(e) {
            this.setStyle({ color: defaultColor });
          },
          tooltip: 'District ' + district.name
        });
      });

      return polygons;
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('cityCouncilDistrictsView/reset');
      this.$store.dispatch('cityCouncilDistrictsView/fetch');
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full');
    next();
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilterDate__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilterDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FilterDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterMapActive__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterMapActive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FilterMapActive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_barCharts_DamageCosts__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_barCharts_DamageCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_barCharts_DamageCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collisions_Collision__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collisions_Collision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__collisions_Collision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__collisions_CollisionMap__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__collisions_CollisionMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__collisions_CollisionMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__collisions_PageTitle__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__collisions_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__collisions_PageTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__collisions_Who__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__collisions_Who___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__collisions_Who__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collisions',

  components: {
    'FilterDate': __WEBPACK_IMPORTED_MODULE_0__components_FilterDate___default.a,
    'FilterMapActive': __WEBPACK_IMPORTED_MODULE_1__components_FilterMapActive___default.a,
    'FilterSubmitButton': __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton___default.a,
    'PageTitle': __WEBPACK_IMPORTED_MODULE_7__collisions_PageTitle___default.a,

    'AddressTypes': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default.a,
    'JunctionTypes': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default.a,
    'CollisionTypes': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default.a,
    'LightConditions': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default.a,
    'RoadConditions': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default.a,
    'Weather': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_BarChartWithTable___default.a,
    'DamageCosts': __WEBPACK_IMPORTED_MODULE_4__components_barCharts_DamageCosts___default.a,
    'Collision': __WEBPACK_IMPORTED_MODULE_5__collisions_Collision___default.a,
    'CollisionMap': __WEBPACK_IMPORTED_MODULE_6__collisions_CollisionMap___default.a,
    'Who': __WEBPACK_IMPORTED_MODULE_8__collisions_Who___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('collisionsView/resetResults');
    this.$store.dispatch('collisionsView/setFilters');
    this.$store.dispatch('collisionsView/fetchAll', this.filters);
    document.getElementById('app').classList.add('collisions');
  },

  computed: {
    filters: function filters() {
      return this.$store.getters['collisionsView/filters'];
    },
    routeParams: function routeParams() {
      return {
        sd: this.filters.startDate,
        ed: this.filters.endDate,
        m: this.filters.map.active,
        nelat: this.filters.map.bounds.ne.lat,
        nelng: this.filters.map.bounds.ne.lng,
        swlat: this.filters.map.bounds.sw.lat,
        swlng: this.filters.map.bounds.sw.lng
      };
    },
    resultsFilters: function resultsFilters() {
      return this.$store.getters['collisionsView/resultsFilters'];
    },
    isLoading: function isLoading() {
      return this.$store.getters['collisionsView/collisionLocations/get'].length > 0 ? 0 : 1;
    },
    mapActive: function mapActive() {
      return this.$store.getters['collisionsView/filters'].map.active;
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('collisionsView/resetResults');
      this.$store.dispatch('collisionsView/fetchAll', this.filters);
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'collisions') {
      document.getElementById('app').classList.remove('collisions', 's-map-collapsed', 's-map-default', 's-map-medium', 's-map-full');
    }
    next();
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilterLocations__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilterLocations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FilterLocations__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'locations',

  components: {
    'FilterLocations': __WEBPACK_IMPORTED_MODULE_0__components_FilterLocations___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('locationsView/setFilters');
    this.$store.dispatch('locationsView/fetchLocations', this.filters);
  },

  computed: {
    filters: function filters() {
      return this.$store.getters['locationsView/filters'];
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('locationsView/resetResults');
      this.$store.dispatch('locationsView/fetchLocations', this.filters);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_barCharts_DamageCosts__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_barCharts_DamageCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_barCharts_DamageCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tables_SeverityRank__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tables_SeverityRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tables_SeverityRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tables_WhoRank__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tables_WhoRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tables_WhoRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lineCharts_MonthlyCollisions__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lineCharts_MonthlyCollisions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_lineCharts_MonthlyCollisions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Geo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Geo__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'neighborhood',

  components: {
    'AddressTypes': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default.a,
    'JunctionTypes': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default.a,
    'CollisionTypes': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default.a,
    'LightConditions': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default.a,
    'RoadConditions': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default.a,
    'Weather': __WEBPACK_IMPORTED_MODULE_0__components_barCharts_BarChartWithTable___default.a,
    'DamageCosts': __WEBPACK_IMPORTED_MODULE_1__components_barCharts_DamageCosts___default.a,
    'SeverityRank': __WEBPACK_IMPORTED_MODULE_2__components_tables_SeverityRank___default.a,
    'WhoRank': __WEBPACK_IMPORTED_MODULE_3__components_tables_WhoRank___default.a,
    'MonthlyCollisions': __WEBPACK_IMPORTED_MODULE_4__components_lineCharts_MonthlyCollisions___default.a,
    'Geo': __WEBPACK_IMPORTED_MODULE_6__components_Geo___default.a,
    'SeattleCityCouncilInformation': __WEBPACK_IMPORTED_MODULE_5__components_SeattleCityCouncilInformation___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('neighborhoodView/resetResults');
    this.$store.dispatch('neighborhoodView/setFilters');
    this.$store.dispatch('neighborhoodView/fetchAll', { id: this.$store.state.route.params.id, filters: this.filters });
  },

  computed: {
    filters: function filters() {
      return this.$store.getters['neighborhoodView/filters'];
    },
    neighborhoodInfo: function neighborhoodInfo() {
      return this.$store.getters['neighborhoodView/pageInfo/get'];
    },
    multipolygons: function multipolygons() {
      if (typeof this.neighborhoodInfo.multipolygon !== 'undefined') {
        return [{
          data: this.neighborhoodInfo.multipolygon,
          options: {
            color: this.$store.getters.teal.dark.a,
            interactive: false
          }
        }];
      }
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('neighborhoodView/resetResults');
      this.$store.dispatch('neighborhoodView/fetchAll', { slug: this.$store.state.route.params.slug, filters: this.filters });
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full');
    next();
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterDate__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FilterDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_trays_FullList__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_trays_FullList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_trays_FullList__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'neighborhoodRanks',

  data: function data() {
    return {
      dateToggleLabel: 'Custom date range'
    };
  },

  components: {
    'FilterDate': __WEBPACK_IMPORTED_MODULE_1__components_FilterDate___default.a,
    'FilterSubmitButton': __WEBPACK_IMPORTED_MODULE_2__components_FilterSubmitButton___default.a,
    'Costs': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'TotalCollisions': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'Fatalities': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'SeriousInjuries': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'Injuries': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PossibleInjuries': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PeopleInvolved': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PeopleWalking': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PeopleBiking': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'DistractedDriving': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'UnderTheInfluence': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'PropertyDamageOnly': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'ParkedCarsHit': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'Speeding': __WEBPACK_IMPORTED_MODULE_3__components_barCharts_Ranks___default.a,
    'FullList': __WEBPACK_IMPORTED_MODULE_4__components_trays_FullList___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('neighborhoodRanksView/resetResults');
    this.$store.dispatch('neighborhoodRanksView/setFilters');
    this.$store.dispatch('neighborhoodRanksView/fetchAll', this.filters);
  },

  computed: {
    filters: function filters() {
      return this.$store.getters['neighborhoodRanksView/filters'];
    },
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.resultsFilters.startDate).format('MMMM Do, YYYY');
    },
    endDate: function endDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.resultsFilters.endDate).format('MMMM Do, YYYY');
    },
    routeParams: function routeParams() {
      return { sd: this.filters.startDate, ed: this.filters.endDate };
    },
    resultsFilters: function resultsFilters() {
      return this.$store.getters['neighborhoodRanksView/resultsFilters'];
    },
    isLoading: function isLoading() {
      return this.$store.getters['neighborhoodRanksView/costs/get'].length > 0 ? 0 : 1;
    },
    fullListActive: function fullListActive() {
      return this.$store.getters['neighborhoodRanksView/fullList/active'];
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('neighborhoodRanksView/resetResults');
      this.$store.dispatch('neighborhoodRanksView/setFilters');
      this.$store.dispatch('neighborhoodRanksView/fetchAll', this.filters);
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Geo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Geo__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'neighborhoods',

  components: {
    'Geo': __WEBPACK_IMPORTED_MODULE_0__components_Geo___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('neighborhoodsView/reset');
    this.$store.dispatch('neighborhoodsView/fetch');
  },

  computed: {
    neighborhoods: function neighborhoods() {
      return this.$store.getters['neighborhoodsView/get'];
    },
    multipolygons: function multipolygons() {
      var multipolygons = [];
      var vm = this;
      var defaultColor = vm.$store.getters.teal.dark.a;

      this.neighborhoods.forEach(function (neighborhood) {
        multipolygons.push({
          data: neighborhood.multipolygon,
          options: {
            color: defaultColor,
            weight: 2
          },
          click: function click(e) {
            vm.$router.push({ name: 'neighborhood', params: { id: neighborhood.slug } });
          },
          mouseover: function mouseover(e) {
            this.setStyle({ color: vm.$store.getters.orange.default });
          },
          mouseout: function mouseout(e) {
            this.setStyle({ color: defaultColor });
          },
          tooltip: neighborhood.name
        });
      });

      return multipolygons;
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('neighborhoodsView/reset');
      this.$store.dispatch('neighborhoodsView/fetch');
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full');
    next();
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_util__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'data',

  data: function data() {
    return {
      costs: ''
    };
  },

  mounted: function mounted() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__vuex_util__["a" /* makeApiFilterUrl */]('/costs')).then(function (response) {
      vm.costs = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'story'
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'technology'
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toDo'
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collision',

  computed: {
    collision: function collision() {
      return this.$store.getters['collisionsView/collision/get'];
    },
    isActive: function isActive() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.collision).length ? 1 : 0;
    }
  },

  methods: {
    clearCollision: function clearCollision() {
      this.$store.dispatch('collisionsView/collision/reset');
    }
  },

  watch: {
    isActive: function isActive() {
      var app = document.getElementById('app');

      if (this.isActive) {
        app.classList.add('s-tray-active');
      } else {
        app.classList.remove('s-tray-active');
      }
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Geo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Geo__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collisionMap',

  components: {
    'Geo': __WEBPACK_IMPORTED_MODULE_0__components_Geo___default.a
  },

  props: ['mapActive'],

  computed: {
    collisionLocations: function collisionLocations() {
      return this.$store.getters['collisionsView/collisionLocations/get'];
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoaderDots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pageTitle',

  components: {
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_0__components_LoaderDots___default.a
  },

  props: ['resultsFilters'],

  computed: {
    endDate: function endDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.resultsFilters.endDate).format('MMMM Do, YYYY');
    },
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.resultsFilters.startDate).format('MMMM Do, YYYY');
    },
    collisionsTotal: function collisionsTotal() {
      return this.$store.getters['collisionsView/total/get'];
    },
    collisionsTotalFormatted: function collisionsTotalFormatted() {
      return this.collisionsTotal.length === 0 ? '' : Number(this.collisionsTotal).toLocaleString('en');
    },
    isLoading: function isLoading() {
      return this.collisionsTotal.length > 0 ? 0 : 1;
    },
    hasResults: function hasResults() {
      return this.collisionsTotal[0] === -1 ? 0 : 1;
    },
    mapFilterActive: function mapFilterActive() {
      return this.$route.params.m === '1' || this.$route.params.m === 1 ? 1 : 0;
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LoaderDots__);





var labels = {
  cyclists: {
    icon: 'directions_bike',
    singular: 'cyclist involved',
    plural: 'cyclists involved'
  },
  hitparkedcar: {
    icon: 'local_parking',
    singular: 'parked car hit',
    plural: 'parked cars hit'
  },
  inattention: {
    icon: 'visibility_off',
    singular: 'cases due to inattention',
    plural: 'cases due to inattention'
  },
  pedestrians: {
    icon: 'directions_walk',
    singular: 'pedestrian involved',
    plural: 'pedestrians involved'
  },
  people: {
    icon: 'person',
    singular: 'person involved',
    plural: 'people involved'
  },
  speeding: {
    icon: 'fast_forward',
    singular: 'case of speeding',
    plural: 'cases of speeding'
  },
  underinfl: {
    icon: 'blur_on',
    singular: 'case under influence of drugs or alcohol',
    plural: 'cases under influence of drugs or alcohol'
  },
  vehicles: {
    icon: 'directions_car',
    singular: 'vehicle involved',
    plural: 'vehicles involved'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'who',

  components: {
    'LoaderDots': __WEBPACK_IMPORTED_MODULE_1__components_LoaderDots___default.a
  },

  data: function data() {
    return {
      labels: labels
    };
  },

  computed: {
    hasResults: function hasResults() {
      return this.who[0] === -1 ? 0 : 1;
    },
    isLoading: function isLoading() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.who).length === 0 ? 1 : 0;
    },
    who: function who() {
      return this.$store.getters['collisionsView/who/get'];
    }
  }
});

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 101,
	"./af.js": 101,
	"./ar": 108,
	"./ar-dz": 102,
	"./ar-dz.js": 102,
	"./ar-kw": 103,
	"./ar-kw.js": 103,
	"./ar-ly": 104,
	"./ar-ly.js": 104,
	"./ar-ma": 105,
	"./ar-ma.js": 105,
	"./ar-sa": 106,
	"./ar-sa.js": 106,
	"./ar-tn": 107,
	"./ar-tn.js": 107,
	"./ar.js": 108,
	"./az": 109,
	"./az.js": 109,
	"./be": 110,
	"./be.js": 110,
	"./bg": 111,
	"./bg.js": 111,
	"./bm": 112,
	"./bm.js": 112,
	"./bn": 113,
	"./bn.js": 113,
	"./bo": 114,
	"./bo.js": 114,
	"./br": 115,
	"./br.js": 115,
	"./bs": 116,
	"./bs.js": 116,
	"./ca": 117,
	"./ca.js": 117,
	"./cs": 118,
	"./cs.js": 118,
	"./cv": 119,
	"./cv.js": 119,
	"./cy": 120,
	"./cy.js": 120,
	"./da": 121,
	"./da.js": 121,
	"./de": 124,
	"./de-at": 122,
	"./de-at.js": 122,
	"./de-ch": 123,
	"./de-ch.js": 123,
	"./de.js": 124,
	"./dv": 125,
	"./dv.js": 125,
	"./el": 126,
	"./el.js": 126,
	"./en-au": 127,
	"./en-au.js": 127,
	"./en-ca": 128,
	"./en-ca.js": 128,
	"./en-gb": 129,
	"./en-gb.js": 129,
	"./en-ie": 130,
	"./en-ie.js": 130,
	"./en-il": 131,
	"./en-il.js": 131,
	"./en-nz": 132,
	"./en-nz.js": 132,
	"./eo": 133,
	"./eo.js": 133,
	"./es": 136,
	"./es-do": 134,
	"./es-do.js": 134,
	"./es-us": 135,
	"./es-us.js": 135,
	"./es.js": 136,
	"./et": 137,
	"./et.js": 137,
	"./eu": 138,
	"./eu.js": 138,
	"./fa": 139,
	"./fa.js": 139,
	"./fi": 140,
	"./fi.js": 140,
	"./fo": 141,
	"./fo.js": 141,
	"./fr": 144,
	"./fr-ca": 142,
	"./fr-ca.js": 142,
	"./fr-ch": 143,
	"./fr-ch.js": 143,
	"./fr.js": 144,
	"./fy": 145,
	"./fy.js": 145,
	"./gd": 146,
	"./gd.js": 146,
	"./gl": 147,
	"./gl.js": 147,
	"./gom-latn": 148,
	"./gom-latn.js": 148,
	"./gu": 149,
	"./gu.js": 149,
	"./he": 150,
	"./he.js": 150,
	"./hi": 151,
	"./hi.js": 151,
	"./hr": 152,
	"./hr.js": 152,
	"./hu": 153,
	"./hu.js": 153,
	"./hy-am": 154,
	"./hy-am.js": 154,
	"./id": 155,
	"./id.js": 155,
	"./is": 156,
	"./is.js": 156,
	"./it": 157,
	"./it.js": 157,
	"./ja": 158,
	"./ja.js": 158,
	"./jv": 159,
	"./jv.js": 159,
	"./ka": 160,
	"./ka.js": 160,
	"./kk": 161,
	"./kk.js": 161,
	"./km": 162,
	"./km.js": 162,
	"./kn": 163,
	"./kn.js": 163,
	"./ko": 164,
	"./ko.js": 164,
	"./ky": 165,
	"./ky.js": 165,
	"./lb": 166,
	"./lb.js": 166,
	"./lo": 167,
	"./lo.js": 167,
	"./lt": 168,
	"./lt.js": 168,
	"./lv": 169,
	"./lv.js": 169,
	"./me": 170,
	"./me.js": 170,
	"./mi": 171,
	"./mi.js": 171,
	"./mk": 172,
	"./mk.js": 172,
	"./ml": 173,
	"./ml.js": 173,
	"./mn": 174,
	"./mn.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 177,
	"./ms-my": 176,
	"./ms-my.js": 176,
	"./ms.js": 177,
	"./mt": 178,
	"./mt.js": 178,
	"./my": 179,
	"./my.js": 179,
	"./nb": 180,
	"./nb.js": 180,
	"./ne": 181,
	"./ne.js": 181,
	"./nl": 183,
	"./nl-be": 182,
	"./nl-be.js": 182,
	"./nl.js": 183,
	"./nn": 184,
	"./nn.js": 184,
	"./pa-in": 185,
	"./pa-in.js": 185,
	"./pl": 186,
	"./pl.js": 186,
	"./pt": 188,
	"./pt-br": 187,
	"./pt-br.js": 187,
	"./pt.js": 188,
	"./ro": 189,
	"./ro.js": 189,
	"./ru": 190,
	"./ru.js": 190,
	"./sd": 191,
	"./sd.js": 191,
	"./se": 192,
	"./se.js": 192,
	"./si": 193,
	"./si.js": 193,
	"./sk": 194,
	"./sk.js": 194,
	"./sl": 195,
	"./sl.js": 195,
	"./sq": 196,
	"./sq.js": 196,
	"./sr": 198,
	"./sr-cyrl": 197,
	"./sr-cyrl.js": 197,
	"./sr.js": 198,
	"./ss": 199,
	"./ss.js": 199,
	"./sv": 200,
	"./sv.js": 200,
	"./sw": 201,
	"./sw.js": 201,
	"./ta": 202,
	"./ta.js": 202,
	"./te": 203,
	"./te.js": 203,
	"./tet": 204,
	"./tet.js": 204,
	"./tg": 205,
	"./tg.js": 205,
	"./th": 206,
	"./th.js": 206,
	"./tl-ph": 207,
	"./tl-ph.js": 207,
	"./tlh": 208,
	"./tlh.js": 208,
	"./tr": 209,
	"./tr.js": 209,
	"./tzl": 210,
	"./tzl.js": 210,
	"./tzm": 212,
	"./tzm-latn": 211,
	"./tzm-latn.js": 211,
	"./tzm.js": 212,
	"./ug-cn": 213,
	"./ug-cn.js": 213,
	"./uk": 214,
	"./uk.js": 214,
	"./ur": 215,
	"./ur.js": 215,
	"./uz": 217,
	"./uz-latn": 216,
	"./uz-latn.js": 216,
	"./uz.js": 217,
	"./vi": 218,
	"./vi.js": 218,
	"./x-pseudo": 219,
	"./x-pseudo.js": 219,
	"./yo": 220,
	"./yo.js": 220,
	"./zh-cn": 221,
	"./zh-cn.js": 221,
	"./zh-hk": 222,
	"./zh-hk.js": 222,
	"./zh-tw": 223,
	"./zh-tw.js": 223
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 421;

/***/ }),
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card blue"
  }, [_c('h2', {
    staticClass: "card-h2"
  }, [_c('span', [_vm._v("Seattle Council Information")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('ul', {
    staticClass: "link-list blue"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.seattle.gov/council/meet-the-council/find-your-district-and-councilmember"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")]), _vm._v(" Find your district and council member")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.seattle.gov/council/meet-the-council"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("contact_phone")]), _vm._v(" Council contact information")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.seattle.gov/council/calendar"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("date_range")]), _vm._v(" Calendar")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.seattle.gov/council/committees"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("people")]), _vm._v(" Committees")])])])])])
}]}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    class: [{
      's-full-list-active': _vm.fullListActive
    }]
  }, [_c('h1', [_vm._v("The "), _c('span', [_vm._v("12 Seattle neighborhoods")]), _vm._v(" between "), _c('span', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" and "), _c('span', [_vm._v(_vm._s(_vm.endDate))]), _vm._v(" with the "), _c('strong', [_vm._v("highest")]), _vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "well collisions-filters"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "well-content"
  }, [_c('FilterDate', {
    attrs: {
      "default-option": {
        key: 'all',
        label: 'Since January 1st, 2006'
      }
    }
  }), _vm._v(" "), _c('FilterSubmitButton', {
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "routeName": 'neighborhoodRanks',
      "routeParams": _vm.routeParams
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-medium"
  }, [_c('Costs', {
    attrs: {
      "card-color": 'green',
      "card-icon": 'attach_money',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/costs/economic/desc',
        pageTitle: 'Seattle economic costs by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Economic costs',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        titleIcon: 'attach_money',
        color: 'green',
        prefix: '$',
        barColors: this.$store.getters.green.light.a
      },
      "getter": 'neighborhoodRanksView/costs/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a,
      "legend-color": 'green',
      "legend-link": 'neighborhood',
      "label-prefix": ' $'
    }
  }), _vm._v(" "), _c('TotalCollisions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'flare',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/totalcollisions/desc',
        pageTitle: 'Seattle total collisions by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Total collisions',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        titleIcon: 'warning',
        color: 'yellow',
        barColors: this.$store.getters.yellow.default
      },
      "getter": 'neighborhoodRanksView/totalCollisions/get',
      "title": 'Total collisions',
      "bar-color": this.$store.getters.yellow.default,
      "legend-color": 'yellow',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('Fatalities', {
    attrs: {
      "card-color": 'black',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/5/desc',
        pageTitle: 'Seattle fatalities by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Fatalities',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'black',
        barColors: this.$store.getters.black.dark.b
      },
      "getter": 'neighborhoodRanksView/fatalities/get',
      "title": 'Fatalities',
      "bar-color": this.$store.getters.black.dark.b,
      "legend-color": 'black',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('SeriousInjuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/4/desc',
        pageTitle: 'Seattle serious injuries by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Serious injuries',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'red',
        barColors: this.$store.getters.red.dark.b
      },
      "getter": 'neighborhoodRanksView/seriousInjuries/get',
      "title": 'Number of serious injuries',
      "bar-color": this.$store.getters.red.dark.b,
      "legend-color": 'red',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('Injuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/1/desc',
        pageTitle: 'Seattle injuries by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Injuries',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'red',
        barColors: this.$store.getters.red.dark.a
      },
      "getter": 'neighborhoodRanksView/injuries/get',
      "title": 'Number of injuries',
      "bar-color": this.$store.getters.red.dark.a,
      "legend-color": 'red',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PossibleInjuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/3/desc',
        pageTitle: 'Seattle possible injuries by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'possible injuries',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'red',
        barColors: this.$store.getters.red.light.b
      },
      "getter": 'neighborhoodRanksView/possibleInjuries/get',
      "title": 'Collisions with possible injuries',
      "bar-color": this.$store.getters.red.light.b,
      "legend-color": 'red',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PeopleInvolved', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'person',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/personcount/desc',
        pageTitle: 'Seattle people involved by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'People involved',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'orange',
        barColors: this.$store.getters.orange.dark.a
      },
      "getter": 'neighborhoodRanksView/possibleInjuries/get',
      "title": 'Number of people involved',
      "bar-color": this.$store.getters.orange.dark.a,
      "legend-color": 'orange',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PeopleWalking', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'directions_walk',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/pedcount/desc',
        pageTitle: 'Seattle pedestrians involved by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Pedestrians involved',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'orange',
        barColors: this.$store.getters.orange.light.a
      },
      "getter": 'neighborhoodRanksView/peopleWalking/get',
      "title": 'Number of pedestrians involved',
      "bar-color": this.$store.getters.orange.light.a,
      "legend-color": 'orange',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PeopleBiking', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'directions_bike',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/pedcylcount/desc',
        pageTitle: 'Seattle people biking by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'People biking',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'orange',
        barColors: this.$store.getters.orange.light.b
      },
      "getter": 'neighborhoodRanksView/peopleBiking/get',
      "title": 'Number of people biking involved',
      "bar-color": this.$store.getters.orange.light.b,
      "legend-color": 'orange',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('DistractedDriving', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'visibility_off',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/inattentionind/desc',
        pageTitle: 'Seattle distracted driving by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Distracted driving',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'purple',
        barColors: this.$store.getters.purple.dark.a
      },
      "getter": 'neighborhoodRanksView/distractedDriving/get',
      "title": 'Cases of distracted driving',
      "bar-color": this.$store.getters.purple.dark.a,
      "legend-color": 'purple',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('UnderTheInfluence', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'blur_on',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/underinfl/desc',
        pageTitle: 'Seattle DUI by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Driving under the influence',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'purple',
        barColors: this.$store.getters.purple.light.a
      },
      "getter": 'neighborhoodRanksView/underTheInfluence/get',
      "title": 'Cases of DUI',
      "bar-color": this.$store.getters.purple.light.a,
      "legend-color": 'purple',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PropertyDamageOnly', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'toll',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/2/desc',
        pageTitle: 'Seattle property damage only by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Property damage only',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'blue',
        barColors: this.$store.getters.blue.light.a
      },
      "getter": 'neighborhoodRanksView/propertyDamageOnly/get',
      "title": 'Property damage only collisions',
      "bar-color": this.$store.getters.blue.light.a,
      "legend-color": 'blue',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('ParkedCarsHit', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'local_parking',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/hitparkedcar/desc',
        pageTitle: 'Seattle parked cars hit by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Parked cars hit',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'blue',
        barColors: this.$store.getters.blue.light.a
      },
      "getter": 'neighborhoodRanksView/parkedCarsHit/get',
      "title": 'Number of parked cars hit',
      "bar-color": this.$store.getters.blue.light.a,
      "legend-color": 'blue',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('Speeding', {
    attrs: {
      "card-color": 'teal',
      "card-icon": 'fast_forward',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/speeding/desc',
        pageTitle: 'Seattle speeding by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Speeding',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'teal',
        barColors: this.$store.getters.teal.light.a
      },
      "getter": 'neighborhoodRanksView/speeding/get',
      "title": 'Cases of speeding',
      "bar-color": this.$store.getters.teal.light.a,
      "legend-color": 'teal',
      "legend-link": 'neighborhood'
    }
  })], 1), _vm._v(" "), _c('FullList', {
    attrs: {
      "getters": {
        active: 'neighborhoodRanksView/fullList/active',
        fetch: 'neighborhoodRanksView/fullList/fetch',
        filters: 'neighborhoodRanksView/fullList/filters',
        filterParams: 'neighborhoods=all',
        get: 'neighborhoodRanksView/fullList/get',
        options: 'neighborhoodRanksView/fullList/options',
        reset: 'neighborhoodRanksView/fullList/reset',
        toggleActive: 'neighborhoodRanksView/fullList/toggleActive'
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "well-title collisions-filters-title"
  }, [_c('span', [_vm._v("Filter collisions")])])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('span', [_vm._v("District " + _vm._s(_vm.districtInfo.name))]), _vm._v(" collisions since "), _c('span', [_vm._v("January 1, 2006")])]), _vm._v(" "), _c('SeattleCityCouncilInformation'), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-large"
  }, [_c('MonthlyCollisions', {
    attrs: {
      "getters": {
        average: 'neighborhoodView/monthlyCollisions/average',
        monthlyCollisions: 'neighborhoodView/monthlyCollisions/get',
        total: 'neighborhoodView/monthlyCollisions/total'
      }
    }
  }), _vm._v(" "), _c('DamageCosts', {
    attrs: {
      "getter": 'cityCouncilDistrictView/damageCosts/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-small"
  }, [_c('WhoRank', {
    attrs: {
      "getters": {
        rankings: 'cityCouncilDistrictView/whoRank/get'
      }
    }
  }), _vm._v(" "), _c('SeverityRank', {
    attrs: {
      "getters": {
        rankings: 'cityCouncilDistrictView/severityRank/get'
      }
    }
  }), _vm._v(" "), _c('Weather', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'cloud',
      "getter": 'cityCouncilDistrictView/weather/get',
      "table-color": 'blue',
      "title": 'Weather',
      "bar-color": this.$store.getters.blue.light.a,
      "chart-height": 380,
      "x-min-axes-rotation": 75
    }
  }), _vm._v(" "), _c('RoadConditions', {
    attrs: {
      "card-color": 'orange',
      "getter": 'cityCouncilDistrictView/roadConditions/get',
      "table-color": 'orange',
      "title": 'Road conditions',
      "bar-color": this.$store.getters.orange.light.a
    }
  }), _vm._v(" "), _c('LightConditions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'wb_incandescent',
      "getter": 'cityCouncilDistrictView/lightConditions/get',
      "table-color": 'yellow',
      "title": 'Light conditions',
      "bar-color": this.$store.getters.yellow.light.a
    }
  }), _vm._v(" "), _c('CollisionTypes', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'call_split',
      "getter": 'cityCouncilDistrictView/collisionTypes/get',
      "table-color": 'purple',
      "title": 'Collision types',
      "bar-color": this.$store.getters.purple.light.a
    }
  }), _vm._v(" "), _c('JunctionTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'cityCouncilDistrictView/junctionTypes/get',
      "table-color": 'teal',
      "title": 'Junction types',
      "bar-color": this.$store.getters.teal.light.b,
      "chart-height": 520,
      "x-min-axes-rotation": 80
    }
  }), _vm._v(" "), _c('AddressTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'cityCouncilDistrictView/addressTypes/get',
      "table-color": 'teal',
      "title": 'Address types',
      "bar-color": this.$store.getters.teal.light.b
    }
  })], 1), _vm._v(" "), _c('Geo', {
    attrs: {
      "polygons": _vm.polygons
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("The Story")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n            I was really trying to avoid downloading the data from Socrata, organizing it, and creating my own API. Everything up to this point was built in javascript and pulling data directly from data.seattle.gov. But there was no way around it. So, I started building my own back end.\n          ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("\n            Now that the data was organized nicely in my database, I could create new API endpoints pretty easily. I could also now mash up the Seattle Collisions data provided by data.seattle.gov with other data. For instance, the cost and neighborhood data were not part of the data set provided by data.seattle.gov. Now I have a foundation for adding new features. Woot!\n          ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("\n            First, I need to get a job. After that, I would like to continue working on this project. I already have a "), _c('router-link', {
    attrs: {
      "to": {
        name: 'toDo'
      }
    }
  }, [_vm._v("to do list")]), _vm._v(". If you have suggestions, comments, feedback, or want to hire me =) drop me a line at "), _c('a', {
    attrs: {
      "href": "mailto:hello@timganter.io"
    }
  }, [_vm._v("hello@timganter.io")]), _vm._v(".\n          ")], 1), _vm._v(" "), _vm._m(10)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Hi! My name is "), _c('a', {
    attrs: {
      "href": "//timganter.io"
    }
  }, [_vm._v("Tim Ganter")]), _vm._v(" and I make websites.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "//timganter.io"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/tim.jpg",
      "alt": "Tim Ganter"
    }
  })]), _vm._v(" Around fall 2016 I decided to wind down my consulting business "), _c('a', {
    attrs: {
      "href": "//www.studiotenfour.com"
    }
  }, [_vm._v("Studio Ten Four")]), _vm._v(" after 8 years and go back to a full-time salaried position. So, began my job search. "), _c('a', {
    attrs: {
      "href": "//studiotenfour.com/static/TimGanterResume.pdf"
    }
  }, [_vm._v("Resume here")]), _vm._v(". I decided to focus on becoming a better javascript developer and chose to do that within the context of data visualization. I started looking for open data to practice with and wanted to create something that would be useful to someone.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "//seattlegreenways.org"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/sng_logo.jpg",
      "alt": "Seattle Neighborhood Greenways Logo"
    }
  })]), _vm._v(" My co-working space "), _c('a', {
    attrs: {
      "href": "//impacthubseattle.com"
    }
  }, [_vm._v("Impact Hub Seattle")]), _vm._v(" hosts a members lunch every Thursday where announcements are often made by staff and other members. One day, "), _c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/gordonpadelford"
    }
  }, [_vm._v("Gordon Padelford")]), _vm._v(" stood up to introduce himself and his organization "), _c('a', {
    attrs: {
      "href": "//seattlegreenways.org"
    }
  }, [_vm._v("Seattle Neighborhood Greenways")]), _vm._v(". I thought, \"Hey I bet they have some data that could be visualized\". So, I went up to Gordon after the member lunch and asked him. He introduced me to the Executive Director of Seattle Neighborhood Greenways, "), _c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/cathytuttle"
    }
  }, [_vm._v("Cathy Tuttle")]), _vm._v(" and we all chatted a bit in their office at The Hub. They pointed me at the "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/Transportation/SDOT-Collisions/v7k9-7dn4"
    }
  }, [_vm._v("Seattle Collisions data")]), _vm._v(" on "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov"
    }
  }, [_vm._v("data.seattle.gov")]), _vm._v(". I started looking at the data and chipping away at creating something.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v("Proof of concept 1")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            The first thing I did was to see if I could simply display collisions on a map. I started reading up on the API for the Seattle Collisions data hosted by "), _c('a', {
    attrs: {
      "href": "//socrata.com"
    }
  }, [_vm._v("Socrata")]), _vm._v(" and researching what javascript libraries I might need. After a few hours I had "), _c('a', {
    attrs: {
      "href": "//seattlecollisions.timganter.io/proto/1"
    }
  }, [_vm._v("a rough proof of concept")]), _vm._v(" of collisions working. I showed this to Cathy & Gordon and they said \"neat!\". Then the questions started coming. \"Can you show collisions by date?\", \"Can you show collisions in an area?\", \"How hard would it be to total up cost for collisions by severity if I gave you numbers?\". Sure! Let me see what I can do.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "p2"
    }
  }), _vm._v("Proof of concept 2")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            A couple weeks went by. Work got busy. Trump got elected. Then I had a "), _c('a', {
    attrs: {
      "href": "//seattlecollisions.timganter.io/proto/2"
    }
  }, [_vm._v("second proof of concept")]), _vm._v(". More useful than the first version but still not very useful. I wanted to make it better. However, I thought this should be enough to demonstrate my technical competency to employers. I started applying for jobs and while it definitely helped get some attention, turns out it wasn't quite enough to land the job I wanted. \n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "v1"
    }
  }), _vm._v("Version 1")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            A few more weeks went by. Work was still busy. Trump got inaugurated. I started "), _c('a', {
    attrs: {
      "href": "//fortyfive.io"
    }
  }, [_vm._v("another side project")]), _vm._v(" out of frustration. Then I had a rough version of what is now the "), _c('a', {
    attrs: {
      "href": "//seattlecollisions.timganter.io/collisions"
    }
  }, [_vm._v("collisions page")]), _vm._v(". I showed this to Cathy & Gordon and they said \"Wow!\". There we go. That's the reaction I was looking for! =) I showed it around to some friends and got the same \"Wow!\". At this point I felt I was building something that could be really useful to folks interested in this data. Even if it didn't get me a job, at least people would be using it.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "what"
    }
  }), _vm._v("What's next?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Thanks for reading!"), _c('br'), _vm._v("\n            -Tim\n          ")])
}]}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card who",
    attrs: {
      "id": "who"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fetch card-content",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('table', {
    staticClass: "yellow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.who), function(value, index) {
    return _c('tr', [_c('td', [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(_vm.labels[index].icon))]), _vm._v(" " + _vm._s(value !== 1 ? _vm.labels[index].plural : _vm.labels[index].singular))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(value).toLocaleString('en-US')))])])
  }))]) : _c('div', [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2"
  }, [_c('span', [_vm._v("Who")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Metric")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter-date-range",
    class: _vm.cssClass
  }, [_c('div', {
    staticClass: "filter-date-range-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "filter-date-range-start"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "startdatepickertrigger"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('input', {
    staticClass: "filter-date-range-input",
    attrs: {
      "type": "text",
      "id": "start_date_picker",
      "name": "start_date_picker"
    },
    on: {
      "change": _vm.setStartDate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-date-range-thru"
  }, [_vm._v("thru  ")]), _vm._v(" "), _c('div', {
    staticClass: "filter-date-range-end"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "enddatepickertrigger"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('input', {
    staticClass: "filter-date-range-input",
    attrs: {
      "type": "text",
      "id": "end_date_picker",
      "name": "end_date_picker"
    },
    on: {
      "change": _vm.setEndDate
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-date-range-error",
    class: [{
      's-error': !_vm.isValidEndDate
    }]
  }, [_vm._v("Must be later than first date.")])])])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card monthly-collisions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('LineChart', {
    attrs: {
      "chart-data": _vm.monthlyCollisions,
      "chart-data-label-y": 'Number of collisions',
      "chart-data-label-x": 'Months',
      "legend": _vm.legend,
      "additional-datasets": _vm.additionalDatasets,
      "line-color": _vm.lineColor,
      "border-width": '1',
      "background-color": _vm.backgroundColor,
      "point-border-color": _vm.pointBorderColor,
      "point-background-color": _vm.pointBackgroundColor
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2 s-icon"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v("warning")]), _vm._v(" Monthly Collisions")])])
}]}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card red"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('div', [_c('table', {
    staticClass: "red"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rankings), function(ranking, index) {
    return (ranking !== null) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.labels[index].plural))]), _vm._v(" "), _c('td', [(index !== 'fatalities') ? _c('span', [_vm._v(_vm._s(ranking.rank) + _vm._s(ranking.rank === 1 ? 'st' : '') + _vm._s(ranking.rank === 2 ? 'nd' : '') + _vm._s(ranking.rank === 3 ? 'rd' : '') + _vm._s(ranking.rank > 3 ? 'th' : ''))]) : _c('span', [_vm._v("n/a")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(ranking.amount).toLocaleString('en-US')))])]) : _vm._e()
  }))])]) : _c('div', [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2"
  }, [_c('span', [_vm._v("Severities")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Severity")]), _vm._v(" "), _c('th', [_vm._v("Rank")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-bars"
  }, [_c('div', {
    staticClass: "loader-bar loader-bar-one"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-bar loader-bar-two"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-bar loader-bar-three"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-bar loader-bar-four"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-bar loader-bar-five"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-bars-ball"
  })])
}]}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locations"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('FilterLocations')], 1)])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-dots"
  }, [_c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  })])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-height-100 l-fixed l-top l-right geo",
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "id": "geo"
    }
  }, [_c('div', {
    staticClass: "geo-map-controls-size"
  }, [_c('span', {
    staticClass: "geo-map-grow",
    on: {
      "click": function($event) {
        _vm.adjustMapSize('grow')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('span', {
    staticClass: "geo-map-shrink",
    on: {
      "click": function($event) {
        _vm.adjustMapSize()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons "
  }, [_vm._v("arrow_drop_down")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-height-100 map",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('LoaderDots')], 1)
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [(_vm.hasResults) ? _c('div', {
    staticClass: "fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('div', {
    staticClass: "bar-chart"
  }, [_c('canvas', {
    attrs: {
      "id": _vm.chartid,
      "height": _vm.chartHeight
    }
  })]), _vm._v(" "), (_vm.showLegend) ? _c('div', [(_vm.hasResults) ? _c('ol', {
    staticClass: "l-clearfix bar-legend",
    class: [_vm.legendColor]
  }, [_vm._l((_vm.barChartAmounts), function(amount, index) {
    return _c('li', {
      staticClass: "l-clearfix bar-legend-series"
    }, [(_vm.chartLegendLink) ? _c('router-link', {
      class: 'bar-legend-series-item bar-legend-series-link',
      attrs: {
        "to": {
          name: _vm.chartLegendLink,
          params: {
            id: _vm.barChartIds[index]
          }
        }
      }
    }, [_c('span', {
      staticClass: "bar-legend-title s-icon"
    }, [_c('i', [_vm._v("\n                        " + _vm._s(index + 1) + _vm._s(index === 0 ? 'st' : '') + _vm._s(index === 1 ? 'nd' : '') + _vm._s(index === 2 ? 'rd' : '') + _vm._s(index > 2 ? 'th' : '') + "\n                      ")]), _vm._v("\n                      " + _vm._s(_vm.barChartLabels[index]) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "bar-legend-amount"
    }, [_vm._v(_vm._s(_vm.prefix) + _vm._s(Number(amount).toLocaleString('en-US')))])]) : _c('div', [_c('span', {
      staticClass: "bar-legend-series-item"
    }, [_c('span', {
      staticClass: "bar-legend-title"
    }, [_vm._v(_vm._s(_vm.barChartLabels[index]))]), _vm._v(" "), _c('span', {
      staticClass: "bar-legend-amount"
    }, [_vm._v(_vm._s(_vm.prefix) + _vm._s(Number(amount).toLocaleString('en-US')))])])])], 1)
  }), _vm._v(" "), (_vm.noDataAvailable) ? _c('li', [_c('span', {
    staticClass: "bar-legend-title"
  }, [_vm._v(_vm._s(_vm.noDataAvailable.title))]), _vm._v(" "), _c('span', {
    staticClass: "bar-legend-amount"
  }, [_vm._v(_vm._s(_vm.prefix) + _vm._s(Number(_vm.noDataAvailable.amount).toLocaleString('en-US')))])]) : _vm._e()], 2) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "bar-message",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('p', [_vm._v("No results that match those filters.")])]), _vm._v(" "), _c('div', {
    staticClass: "bar-loader",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderBars')], 1)])
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-submit",
    attrs: {
      "id": "filtersubmit"
    }
  }, [_c('button', {
    staticClass: "filter-submit-button",
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v("\n      Reload "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cached")])])])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tray full-list",
    class: [{
      active: _vm.isActive
    }, _vm.options.color],
    attrs: {
      "id": "fulllist"
    }
  }, [_c('h1', {
    staticClass: "full-list-title"
  }, [_vm._v(_vm._s(_vm.options.pageTitle))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons tray-icon-close full-list-icon-close",
    on: {
      "click": _vm.closeList
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    class: _vm.options.color
  }, [_c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.options.titleIcon
    }]
  }, [_c('span', [(_vm.options.titleIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.options.titleIcon))]) : _vm._e(), _vm._v(" \n        " + _vm._s(_vm.options.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "chart-type": 'bar',
      "chart-data": _vm.fullList,
      "chart-height": 75,
      "bar-color": _vm.options.barColors,
      "show-legend": false,
      "label-prefix": _vm.options.prefix
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card",
    class: _vm.options.color
  }, [_c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.options.titleIcon
    }]
  }, [_c('span', [(_vm.options.titleIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.options.titleIcon))]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.options.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', {
    staticClass: "fetch navigation-board",
    class: [{
      'is-loading': _vm.isLoading
    }, _vm.options.color]
  }, [(_vm.options.ths) ? _c('thead', [_c('tr', _vm._l((_vm.options.ths), function(heading) {
    return _c('th', [_vm._v(_vm._s(heading))])
  }))]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.fullList), function(rankItem, index) {
    return _c('tr', {
      staticClass: "full-list-row"
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.options.link,
          params: {
            id: rankItem.id
          }
        }
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.options.link,
          params: {
            id: rankItem.id
          }
        }
      }
    }, [_vm._v(_vm._s(rankItem.title))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.options.link,
          params: {
            id: rankItem.id
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.options.prefix) + _vm._s(Number(rankItem.amount).toLocaleString('en-US')))])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-fixed l-height-100 sidebar"
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    on: {
      "click": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons sidebar-menu-icon"
  }, [_vm._v("menu")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons sidebar-close-icon"
  }, [_vm._v("close")]), _vm._v(" "), _c('span', [_vm._v("Hide Sidebar")])]), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('Contact')], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter-map-active",
    attrs: {
      "id": "filtermapactive"
    }
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "name": "filtermapactive",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.get
    },
    on: {
      "change": _vm.set
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider round"
  })])])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("The Technology")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("\n          As mentioned in "), _c('a', {
    attrs: {
      "href": "/about/story#p2"
    }
  }, [_vm._v("the story")]), _vm._v(", the data is being downloaded from a \n          "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/resource/v7k9-7dn4.json"
    }
  }, [_vm._v("json feed provided by data.seattle.gov")]), _vm._v(". There is a job scheduled that will download collisions \n          from the past 150 days, check for changes, then update existing collisions and create new ones. I'd like to write a blog post sometime that talks more \n          about the import process, how I transformed the data, and challenges I ran into. This is on my "), _c('router-link', {
    attrs: {
      "to": {
        name: 'toDo'
      }
    }
  }, [_vm._v("to do list")]), _vm._v(".\n        ")], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#front"
    }
  }, [_vm._v("Front end")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#back"
    }
  }, [_vm._v("Back end")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#vendors"
    }
  }, [_vm._v("Vendors")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "front"
    }
  }), _vm._v("Front end")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The front end is built with "), _c('a', {
    attrs: {
      "href": "//vuejs.org"
    }
  }, [_vm._v("VueJs")]), _vm._v(". If you are new to VueJS, there is "), _c('a', {
    attrs: {
      "href": "//vuecasts.com"
    }
  }, [_vm._v("video tutorial series\n          for FREE DOLLARS!")]), _vm._v(" Put together by "), _c('a', {
    attrs: {
      "href": "//twitter.com/jeffrey_way"
    }
  }, [_vm._v("Jeffery Way")]), _vm._v(" at "), _c('a', {
    attrs: {
      "href": "//laracasts.com"
    }
  }, [_vm._v("Laracasts")]), _vm._v(". \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//github.com/vuejs/vue-cli"
    }
  }, [_vm._v("Vue-CLI")]), _vm._v(" to scaffold out WebPack 2 and my directory structure")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//webpack.js.org"
    }
  }, [_vm._v("WebPack 2")]), _vm._v(" for module bundling & build process")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//router.vuejs.org/en"
    }
  }, [_vm._v("Vue-Router")]), _vm._v(" for URL routing")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//vuex.vuejs.org/en/intro.html"
    }
  }, [_vm._v("Vuex")]), _vm._v(" for state management")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/vuejs/vuex-router-sync"
    }
  }, [_vm._v("Vuex router sync")]), _vm._v(" for keeping router in sync with storage.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.chartjs.org"
    }
  }, [_vm._v("ChartJS")]), _vm._v(" for pie, bar, & line charts")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//leafletjs.com"
    }
  }, [_vm._v("Leaflet")]), _vm._v(" for maps")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/Leaflet/Leaflet.markercluster"
    }
  }, [_vm._v("Leaflet.markercluster")]), _vm._v(" for clustering points on a map")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/Leaflet/Leaflet.heat"
    }
  }, [_vm._v("Leaflet.heat")]), _vm._v(" for heatmap effect on maps")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//momentjs.com"
    }
  }, [_vm._v("MomentJS")]), _vm._v(" for date formatting and manipulation")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/dbushell/Pikaday"
    }
  }, [_vm._v("Pikaday")]), _vm._v(" for date pickers")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//meyerweb.com/eric/tools/css/reset/"
    }
  }, [_vm._v("Eric Meyer's CSS Reset")]), _vm._v(" for css reset")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//lodash.com"
    }
  }, [_vm._v("Lodash")]), _vm._v(" for utility")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/mzabriskie/axios"
    }
  }, [_vm._v("Axios")]), _vm._v(" for async promise based API calls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "back"
    }
  }), _vm._v("Back end")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          I'm a PHP developer so I built the backend in "), _c('a', {
    attrs: {
      "href": "//www.php.net"
    }
  }, [_vm._v("PHP")]), _vm._v(". I like the "), _c('a', {
    attrs: {
      "href": "//laravel.com"
    }
  }, [_vm._v("Laravel PHP framework")]), _vm._v(", so I used that.\n          If you're new to Laravel, guess what? There is ANOTHER "), _c('a', {
    attrs: {
      "href": "//laravelfromscratch.com"
    }
  }, [_vm._v("video tutorial series to help you get started with Laravel")]), _vm._v(". Also\n          for FREE DOLLARS by "), _c('a', {
    attrs: {
      "href": "//twitter.com/jeffery_way"
    }
  }, [_vm._v("Jeffery Way")]), _vm._v(". Whatta guy! If you're looking for a book on Laravel, well lucky you.\n          "), _c('a', {
    attrs: {
      "href": "//mattstauffer.co"
    }
  }, [_vm._v("Matt Stauffer")]), _vm._v(" recently published his book "), _c('a', {
    attrs: {
      "href": "//laravelupandrunning.com"
    }
  }, [_vm._v("Laravel Up & Running")]), _vm._v(". I bought it. It's good.\n          I'm using "), _c('a', {
    attrs: {
      "href": "//www.mysql.com"
    }
  }, [_vm._v("MySQL")]), _vm._v(" for my database.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "back"
    }
  }), _vm._v("Vendors")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//www.webfaction.com/?aid=45281"
    }
  }, [_vm._v("WebFaction")]), _vm._v(" for hosting the front end VueJS app")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.digitalocean.com"
    }
  }, [_vm._v("Digital Ocean")]), _vm._v(" for hosting the back end Laravel app serving up the API.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//forge.laravel.com"
    }
  }, [_vm._v("Laravel Forge")]), _vm._v(" for server provisioning")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//envoyer.io"
    }
  }, [_vm._v("Envoyer.io")]), _vm._v(" for deployment")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.cloudflare.com"
    }
  }, [_vm._v("CloudFlare")]), _vm._v(" for DNS")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.bitbucket.org"
    }
  }, [_vm._v("BitBucket")]), _vm._v(" for Git repository")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//gandi.net"
    }
  }, [_vm._v("Gandi")]), _vm._v(" for domain registration")])])
}]}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_c('Multiselect', {
    attrs: {
      "id": "ajax",
      "track-by": "id",
      "label": "desc",
      "placeholder": "Type to search",
      "value": _vm.resultsLocations,
      "options": _vm.results,
      "multiple": true,
      "searchable": true,
      "loading": _vm.isLoading,
      "internal-search": false,
      "clear-on-select": false,
      "close-on-select": false,
      "options-limit": 300,
      "limit": 3,
      "limit-text": _vm.limitText
    },
    on: {
      "search-change": _vm.search,
      "select": _vm.addSelectedLocationId,
      "remove": _vm.removeSelectedLocationId
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])]), _vm._v(" "), _c('div', {
    staticClass: "locations-submit",
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "id": "locations-submit"
    },
    on: {
      "click": _vm.goTo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('PageTitle', {
    attrs: {
      "results-filters": _vm.resultsFilters
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "well collisions-filters"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "well-content"
  }, [_c('FilterDate', {
    attrs: {
      "default-option": {
        key: '2023',
        label: '2023'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-map"
  }, [_c('span', {
    staticClass: "filter-map-label"
  }, [_vm._v("Limit results to map area?")]), _vm._v(" "), _c('FilterMapActive')], 1), _vm._v(" "), _c('FilterSubmitButton', {
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "routeName": 'collisions',
      "routeParams": _vm.routeParams
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-small"
  }, [_c('Who'), _vm._v(" "), _c('DamageCosts', {
    attrs: {
      "getter": 'collisionsView/damageCosts/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a,
      "chart-height": 300
    }
  }), _vm._v(" "), _c('Weather', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'cloud',
      "getter": 'collisionsView/weather/get',
      "table-color": 'blue',
      "title": 'Weather',
      "bar-color": this.$store.getters.blue.light.a,
      "chart-height": 380,
      "x-min-axes-rotation": 75
    }
  }), _vm._v(" "), _c('RoadConditions', {
    attrs: {
      "card-color": 'orange',
      "getter": 'collisionsView/roadConditions/get',
      "table-color": 'orange',
      "title": 'Road conditions',
      "bar-color": this.$store.getters.orange.light.a,
      "chart-height": 380
    }
  }), _vm._v(" "), _c('LightConditions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'wb_incandescent',
      "getter": 'collisionsView/lightConditions/get',
      "table-color": 'yellow',
      "title": 'Light conditions',
      "bar-color": this.$store.getters.yellow.light.a,
      "chart-height": 310
    }
  }), _vm._v(" "), _c('CollisionTypes', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'call_split',
      "getter": 'collisionsView/collisionTypes/get',
      "table-color": 'purple',
      "title": 'Collision types',
      "bar-color": this.$store.getters.purple.light.a,
      "chart-height": 310
    }
  }), _vm._v(" "), _c('JunctionTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'collisionsView/junctionTypes/get',
      "table-color": 'teal',
      "title": 'Junction types',
      "bar-color": this.$store.getters.teal.light.b,
      "chart-height": 520,
      "x-min-axes-rotation": 80
    }
  }), _vm._v(" "), _c('AddressTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'collisionsView/addressTypes/get',
      "table-color": 'teal',
      "title": 'Address types',
      "bar-color": this.$store.getters.teal.light.b
    }
  })], 1), _vm._v(" "), _c('CollisionMap', {
    attrs: {
      "map-active": _vm.mapActive
    }
  }), _vm._v(" "), _c('Collision')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card red"
  }, [_c('h2', {
    staticClass: "card-h2",
    staticStyle: {
      "padding": "1em"
    }
  }, [_vm._v("NOTE: Data is available from 2006 to June 1, 2023.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "well-title collisions-filters-title"
  }, [_c('span', [_vm._v("Filter collisions")])])
}]}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("To Do")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("\n          After I find I job, I plan to continue working on this project. Below is a list of things I'd like to do. In no particular order.\n          If you find something interesting, have questions, or suggestions, I can be reached at "), _c('a', {
    attrs: {
      "href": "mailto:hello@timganter.io"
    }
  }, [_vm._v("hello@timganter.io")]), _vm._v(".\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Investigate features that can take advantage of geolocation on devices. For example, \"collisions near me\".")]), _vm._v(" "), _c('li', [_vm._v("Investigate other ways of measuring / ranking. Per captia? Per square mile? Percentage of collisions? Etc.")]), _vm._v(" "), _c('li', [_vm._v("Toggle between economic and comprehensive costs.")]), _vm._v(" "), _c('li', [_vm._v("Ability to draw a custom boundary")]), _vm._v(" "), _c('li', [_vm._v("Investigate open sourcing the project")]), _vm._v(" "), _c('li', [_vm._v("Think about other data sets that I could combine this with")]), _vm._v(" "), _c('li', [_vm._v("Investigate predictive analysis. Can I use the data to predict conditions of a car crash? Severity of a car crash? TensorFlow!?!")]), _vm._v(" "), _c('li', [_vm._v("Add location pins to map on neighborhood view. Click on pin and see all collisions for that location.")]), _vm._v(" "), _c('li', [_vm._v("Make collisions by location. Enter locations and then view collisions for those locations.")]), _vm._v(" "), _c('li', [_vm._v("Investigate ways to analyze locations. Ex. location with most pedestrians hit, most injuries, etc. ")]), _vm._v(" "), _c('li', [_vm._v("\n            Make additional views that could reveal interesting trends. For example...Day of the week with most collisions. \n            Month with the most collisions, etc.\n          ")]), _vm._v(" "), _c('li', [_vm._v("Look into server-side rendering.")]), _vm._v(" "), _c('li', [_vm._v("Look into service workers & Progressive Web Apps.")]), _vm._v(" "), _c('li', [_vm._v("Light refactoring for front end code.")]), _vm._v(" "), _c('li', [_vm._v("Light refactoring for back end code.")]), _vm._v(" "), _c('li', [_vm._v("Look at areas to improve performance. Especially with map rendering lots of data.")])])])])])])
}]}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card yellow"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('div', [_c('table', {
    staticClass: "yellow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rankings), function(ranking, index) {
    return (ranking !== null) ? _c('tr', [_c('td', [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(_vm.labels[index].icon))]), _vm._v("  " + _vm._s(_vm.labels[index].plural))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ranking.rank) + _vm._s(ranking.rank === 1 ? 'st' : '') + _vm._s(ranking.rank === 2 ? 'nd' : '') + _vm._s(ranking.rank === 3 ? 'rd' : '') + _vm._s(ranking.rank > 3 ? 'th' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(ranking.amount).toLocaleString('en-US')))])]) : _vm._e()
  }))])]) : _c('div', [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2"
  }, [_c('span', [_vm._v("Who")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Metric")]), _vm._v(" "), _c('th', [_vm._v("Rank")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-clearfix line"
  }, [_c('div', {
    staticClass: "fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('div', {
    staticClass: "line-chart"
  }, [_c('canvas', {
    attrs: {
      "id": _vm.chartid
    }
  })]), _vm._v(" "), (_vm.hasResults) ? _c('div', {
    staticClass: "line-legend"
  }, [_c('ul', _vm._l((_vm.legend), function(series) {
    return _c('li', [_c('span', {
      staticClass: "line-legend-series-label"
    }, [_vm._v(_vm._s(series.label))])])
  }))]) : _c('div', {
    staticClass: "line-message",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots line-loader",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'collisionsIndex'
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("flare")]), _vm._v(" "), _c('span', [_vm._v("Collisions")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("gavel")]), _vm._v(" "), _c('span', [_vm._v("City Council Districts")]), _c('i', {
    staticClass: "material-icons nav-toggle-arrow"
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'cityCouncilDistricts'
      }
    }
  }, [_c('span', [_vm._v("List")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'cityCouncilDistrictRanksIndex'
      }
    }
  }, [_c('span', [_vm._v("Ranks")])])], 1)])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("nature_people")]), _vm._v(" "), _c('span', [_vm._v("Neighborhood")]), _c('i', {
    staticClass: "material-icons nav-toggle-arrow"
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'neighborhoods'
      }
    }
  }, [_c('span', [_vm._v("List")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'neighborhoodRanksIndex'
      }
    }
  }, [_c('span', [_vm._v("Ranks")])])], 1)])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-toggle",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("info_outline")]), _vm._v(" "), _c('span', [_vm._v("About")]), _c('i', {
    staticClass: "material-icons nav-toggle-arrow"
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/blog/the-story"
    }
  }, [_c('span', [_vm._v("The Story")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/the-data"
    }
  }, [_c('span', [_vm._v("The Data")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/the-technology"
    }
  }, [_c('span', [_vm._v("The Technology")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/media-coverage"
    }
  }, [_c('span', [_vm._v("In The Media")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/todo"
    }
  }, [_c('span', [_vm._v("To Do")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/blog"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("library_books")]), _vm._v(" "), _c('span', [_vm._v("Blog")])])])
}]}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardColor
  }, [_c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.cardIcon
    }]
  }, [_c('span', [(_vm.cardIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.cardIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "bar-color": _vm.barColor,
      "chart-data": _vm.chartData,
      "chart-height": _vm.chartHeight,
      "chart-type": _vm.chartType,
      "label-prefix": _vm.labelPrefix,
      "legend-color": _vm.legendColor,
      "legend-link": _vm.legendLink,
      "show-legend": _vm.showLegend,
      "stacked": _vm.stacked,
      "x-max-axes-rotation": _vm.xMaxAxesRotation,
      "x-min-axes-rotation": _vm.xMinAxesRotation
    }
  }), _vm._v(" "), _c('table', {
    class: _vm.tableColor
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.amounts), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.count).toLocaleString('en-US')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.percent).toLocaleString('en-US', {
      maximumFractionDigits: 2
    })) + "%")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(Number(data.amount).toLocaleString('en-US')))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "highlight",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "highlight"
  }, [_vm._v("$" + _vm._s(Number(_vm.tableData.total).toLocaleString('en-US')))])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Severity")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("% of Cost")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardColor
  }, [(_vm.title) ? _c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.cardIcon
    }]
  }, [_c('span', [(_vm.cardIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.cardIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "bar-color": _vm.barColor,
      "chart-data": _vm.chartData,
      "chart-height": _vm.chartHeight,
      "chart-type": _vm.chartType,
      "label-prefix": _vm.labelPrefix,
      "legend-color": _vm.legendColor,
      "legend-link": _vm.legendLink,
      "show-legend": _vm.showLegend,
      "stacked": _vm.stacked,
      "x-max-axes-rotation": _vm.xMaxAxesRotation,
      "x-min-axes-rotation": _vm.xMinAxesRotation
    }
  })], 1), _vm._v(" "), (_vm.hasResults) ? _c('button', {
    staticClass: "btn full-list-button",
    on: {
      "click": _vm.loadFullList
    }
  }, [_vm._v("Full list")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("The Data")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("There are four data sets shown on this site.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('blockquote', [_vm._v("\n          \"Displays the locations and attributes of collisions that occur within Seattle. All collisions are provided by the Seattle Police Department and Washington State Department of Transportation and are recorded by Traffic Records for the last 10 years. This includes all types of collisions. Collisions are shown at the intersection or mid-block of a street segment that is closest to where it occurred.\"\n        ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("\n          Building this site required combining the knowledge stored in these two different places. The knowledge stored in the PDF and the knowledge of how to use Socrata's API. The PDF from SDOT tells us what the data means and Socrata's developer portal tells us how to access the data and what format it is stored in. \n        ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n          The data from the Seattle Department of Transportation (SDOT) has the following five levels of severity. \n        ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("\n          We mapped the NSC severities to the SDOT severities as follows.  \n        ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('blockquote', [_vm._v("\n          \"The figures above are appropriate for measuring the economic loss to a community resulting from past motor-vehicle crashes. They should not be used, however, in computing the dollar value of future benefits due to traffic safety measures because they do not include the value of a person's natural desire to live longer or to protect the quality of one's life. That is, the economic loss estimates do not include what people are willing to pay for improved safety.\"\n        ")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/cathytuttle"
    }
  }, [_vm._v("Cathy Tuttle")]), _vm._v(" recommended we use the more conservative economic costs number. Below is a table for the economic costs used for the calculations in this application. The headings are the NSC label / SDOT label. It would be nice to have the ability to switch between economic & comprehensive costs. I have this on my "), _c('router-link', {
    attrs: {
      "to": {
        name: 'toDo'
      }
    }
  }, [_vm._v("to do list")]), _vm._v(". \n        ")], 1), _vm._v(" "), _c('table', {
    staticClass: "teal small"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.costs), function(cost, year) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(year))]), _vm._v(" "), _vm._l((cost), function(dollars) {
      return _c('td', [_vm._v("$" + _vm._s(Number(dollars.amount).toLocaleString('en-US')))])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(cost[0].desc))])], 2)
  }))]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', [_vm._v("\n          With some refactoring from my code to create the neighborhood boundaries, I imported the City Council District boundaries, created similar API endpoints, and similar views. I'd like to make these district views better. Perhaps show a list of neighborhoods within each district!\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#sdot"
    }
  }, [_vm._v("Seattle Department of Transportation (SDOT) Collisions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#costs"
    }
  }, [_vm._v("Economic costs of collision severity")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#neighborhoods"
    }
  }, [_vm._v("Seattle neighborhood geospatial boundaries")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#districts"
    }
  }, [_vm._v("Seattle City Council District geospatial boundaries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "sdot"
    }
  }), _vm._v("Seattle Department of Transportation (SDOT) Collisions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          According to description on the "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/Transportation/SDOT-Collisions/v7k9-7dn4/about"
    }
  }, [_vm._v("SDOT Collisions about page")]), _vm._v(" as of Sunday May 21, 2017 10:52pm PST, this data is described as...\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          There is a "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/api/assets/486A95FC-CA9B-4360-97E0-58FB5C35DA5F?download=true"
    }
  }, [_vm._v("PDF that describes the data fields available")]), _vm._v(". There is also a "), _c('a', {
    attrs: {
      "href": "//dev.socrata.com/foundry/data.seattle.gov/v7k9-7dn4"
    }
  }, [_vm._v("json feed to the data provided by Socrata")]), _vm._v(". Socrata is the company hired by the city to host their open data. They provide the platform & software. However, it is up to the city to use Socrata, enter the data, make sure the data is accurate, and answer questions about the data. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "costs"
    }
  }), _vm._v("Economic costs of collision severity")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Every year the "), _c('a', {
    attrs: {
      "href": "//www.nsc.org"
    }
  }, [_vm._v("National Safety Council (NSC)")]), _vm._v(" publishes their "), _c('a', {
    attrs: {
      "href": "http://www.nsc.org/learn/safety-knowledge/Pages/injury-facts.aspx"
    }
  }, [_vm._v("Injury Facts®")]), _vm._v(" report. This report includes an estimated \"Cost of Motor-Vehicle Injuries\". Here is a "), _c('a', {
    attrs: {
      "href": "//www.nsc.org/NSCDocuments_Corporate/estimating-costs.pdf"
    }
  }, [_vm._v("sample of a Cost of Motor-Vehicle Injuries report")]), _vm._v(". The National Safety Council categorizes collisions with the following six levels of severity. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Death")]), _vm._v(" "), _c('li', [_vm._v("Disabling")]), _vm._v(" "), _c('li', [_vm._v("Evident")]), _vm._v(" "), _c('li', [_vm._v("Possible")]), _vm._v(" "), _c('li', [_vm._v("No injury observed")]), _vm._v(" "), _c('li', [_vm._v("Property damage only")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Fatality collision (sdot code 3)")]), _vm._v(" "), _c('li', [_vm._v("Serious injury collision (sdot code 2b)")]), _vm._v(" "), _c('li', [_vm._v("Injury (sdot code 2)")]), _vm._v(" "), _c('li', [_vm._v("Unknown (sdot code 0)")]), _vm._v(" "), _c('li', [_vm._v("Property damage only collision (sdot code 1)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Death (nsc) -> Fatality collision (sdot code 3)")]), _vm._v(" "), _c('li', [_vm._v("Disabling (nsc) -> Serious injury collision (sdot code 2b)")]), _vm._v(" "), _c('li', [_vm._v("Evident (nsc) -> Injury (sdot code 2)")]), _vm._v(" "), _c('li', [_vm._v("Possible (nsc) -> Unknown (sdot code 0)")]), _vm._v(" "), _c('li', [_vm._v("Property damage only (nsc) -> Property damage only collision (sdot code 1)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The National Safety Council also has TWO sets of estimated costs, \"economic\" and \"comprehensive\" costs. In the "), _c('a', {
    attrs: {
      "href": "//www.nsc.org/NSCDocuments_Corporate/estimating-costs.pdf"
    }
  }, [_vm._v("sample report")]), _vm._v(" the National Safety Council says the following about the meaning of \"Economic Costs\".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          So, the \"economic cost\" is basically the cost of the "), _c('em', [_vm._v("past damage")]), _vm._v(" done by collisions where comprehensive costs includes a person's desires for the future. Notice in the "), _c('a', {
    attrs: {
      "href": "//www.nsc.org/NSCDocuments_Corporate/estimating-costs.pdf"
    }
  }, [_vm._v("sample report")]), _vm._v(", the economic costs are lower than the comprehensive cost since economic costs do not include benefits gained from safety improvement investments and changes in quality of life of those involved in a collision.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("Death / Fatality")]), _vm._v(" "), _c('th', [_vm._v("Disabling / Serious injury")]), _vm._v(" "), _c('th', [_vm._v("Evident injury / Injury")]), _vm._v(" "), _c('th', [_vm._v("Possible injury / Severity unknown")]), _vm._v(" "), _c('th', [_vm._v("Property damage only / property damage")]), _vm._v(" "), _c('th', [_vm._v("Notes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "neighborhoods"
    }
  }), _vm._v("Seattle neighborhood geospatial boundaries")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/Transportation/SDOT-Collisions/v7k9-7dn4/about"
    }
  }, [_vm._v("data provided by the Seattle Department of Transportation")]), _vm._v(" includes latitude & longitude coordinates for a collision. However, we don't know what neighborhood these coodinates fall in. I wanted to be able to view collisions by neighborhood so I had to find neighborhoood geospatial boundaries. Turns out that "), _c('a', {
    attrs: {
      "href": "https://www.zillow.com/howto/api/neighborhood-boundaries.htm"
    }
  }, [_vm._v("Zillow has neighborhood boundaries in shapefiles")]), _vm._v(". However, this does me little good since I need the coordinates in a format that I can store in my database. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          After some searching on GitHub I found a "), _c('a', {
    attrs: {
      "href": "//github.com/mashvisor/us-neighborhoods-boundaries"
    }
  }, [_vm._v("repository by Mashvisor that has the Zillow shape files converted into GeoJSON and CSV")]), _vm._v(". The "), _c('a', {
    attrs: {
      "href": "//github.com/mashvisor/us-neighborhoods-boundaries/blob/master/out/csv/WA-Regions.csv"
    }
  }, [_vm._v(".csv file for Washington State")]), _vm._v(" is the one I used to create the multipolygon datatypes in my database. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "districts"
    }
  }), _vm._v("Seattle City Council geospatial boundaries")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/cathytuttle"
    }
  }, [_vm._v("Cathy")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/gordonpadelford"
    }
  }, [_vm._v("Gordon")]), _vm._v(" mentioned that it would be interesting to see collisions by district. I attened an "), _c('a', {
    attrs: {
      "href": "http://openseattle.org/"
    }
  }, [_vm._v("Open Seattle")]), _vm._v(" meetup and "), _c('a', {
    attrs: {
      "href": "https://github.com/JacksonMaxfield"
    }
  }, [_vm._v("Jackson Maxfield")]), _vm._v(" introduced me to "), _c('a', {
    attrs: {
      "href": "http://seattle.io"
    }
  }, [_vm._v("Seattle.io")]), _vm._v(". I don't know why I didn't come across this before! Turns out there are "), _c('a', {
    attrs: {
      "href": "https://github.com/seattleio/seattle-boundaries-data/tree/master/data"
    }
  }, [_vm._v("a bunch of boundaries available")]), _vm._v(" here including "), _c('a', {
    attrs: {
      "href": "https://github.com/seattleio/seattle-boundaries-data/blob/master/data/city-council-districts.geojson"
    }
  }, [_vm._v("City Council Districts")]), _vm._v(". Yay!\n        ")])
}]}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Seattle Neighborhoods")]), _vm._v(" "), _c('ul', {
    staticClass: "l-grid l-grid-xsmall"
  }, _vm._l((_vm.neighborhoods), function(neighborhood) {
    return _c('li', [_c('router-link', {
      staticClass: "mini-card",
      attrs: {
        "to": {
          name: 'neighborhood',
          params: {
            id: neighborhood.slug
          }
        }
      }
    }, [_vm._v(_vm._s(neighborhood.name))])], 1)
  })), _vm._v(" "), _c('Geo', {
    attrs: {
      "multipolygons": _vm.multipolygons
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-date",
    attrs: {
      "id": "filterdate"
    }
  }, [_c('FilterDatePreset', {
    attrs: {
      "default-option": this.defaultOption
    }
  }), _vm._v(" "), _c('FilterDateRange'), _vm._v(" "), _c('div', {
    staticClass: "filter-date-toggle"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDateFilter()
      }
    }
  }, [_vm._v(_vm._s(_vm.dateToggleLabel))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collisions-page-title",
    class: [{
      'map-filter-active': _vm.mapFilterActive
    }]
  }, [_c('h1', {
    staticClass: "fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.collisionsTotalFormatted))]), _vm._v(" collisions between\n      "), _c('span', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" and "), _c('span', [_vm._v(_vm._s(_vm.endDate))]), _vm._v("\n      in "), (_vm.mapFilterActive) ? _c('em', [_vm._v("map area")]) : _c('em', [_vm._v("all of Seattle")])]) : _c('div', [_vm._v("No collisions found matching those filters.")])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardColor
  }, [(_vm.title) ? _c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.cardIcon
    }]
  }, [_c('span', [(_vm.cardIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.cardIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "bar-color": _vm.barColor,
      "chart-data": _vm.chartData,
      "chart-height": _vm.chartHeight,
      "chart-type": _vm.chartType,
      "label-prefix": _vm.labelPrefix,
      "legend-color": _vm.legendColor,
      "legend-link": _vm.legendLink,
      "show-legend": _vm.showLegend,
      "stacked": _vm.stacked,
      "x-max-axes-rotation": _vm.xMaxAxesRotation,
      "x-min-axes-rotation": _vm.xMinAxesRotation
    }
  }), _vm._v(" "), (_vm.json.amounts && _vm.json.amounts.length) ? _c('table', {
    class: _vm.tableColor
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Count")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.chartData), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.percent).toLocaleString('en-US', {
      maximumFractionDigits: 2
    })) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.amount).toLocaleString('en-US')))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "highlight",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(Number(_vm.json.total).toLocaleString('en-US')))])]), _vm._v(" "), (_vm.noDataAvailable) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No data available")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(_vm.noDataAvailable.amount).toLocaleString('en-US')))])]) : _vm._e()])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('h2', [_c('a', {
    on: {
      "click": function($event) {
        _vm.openSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("contact_mail")]), _vm._v(" "), _c('span', [_vm._v("Contact")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "mailto:hello@timganter.io"
    }
  }, [_vm._v("hello@timganter.io")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//twitter.com/timganter"
    }
  }, [_vm._v("@timganter")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/timganter"
    }
  }, [_vm._v("LinkedIn")])])])
}]}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-date-preset",
    class: _vm.cssClass
  }, [_c('multiselect', {
    attrs: {
      "placeholder": 'Select a date range',
      "options": _vm.options,
      "track-by": 'key',
      "label": 'label',
      "allow-empty": false,
      "searchable": false,
      "deselect-label": '',
      "value": _vm.selection
    },
    on: {
      "select": _vm.setDateRange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-height-100",
    attrs: {
      "id": "app"
    }
  }, [_c('Sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('GoogleAnalytics')], 1)
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tray collision",
    class: [{
      active: _vm.isActive
    }]
  }, [(_vm.collision.date) ? _c('h2', {
    staticClass: "tray-h2 collision-h2"
  }, [_vm._v("\n        " + _vm._s(_vm.collision.date) + " "), (_vm.collision.time) ? _c('span', [_vm._v("@ " + _vm._s(_vm.collision.time))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "material-icons tray-icon-close",
    on: {
      "click": _vm.clearCollision
    }
  }, [_vm._v("close")])]) : _c('div', {
    staticClass: "tray-instructions"
  }, [_vm._v("\n        Loading collision...\n    ")]), _vm._v(" "), (_vm.collision.location) ? _c('h3', {
    staticClass: "tray-h3 collision-h3"
  }, [_vm._v("\n        " + _vm._s(_vm.collision.location) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.collision.date) ? _c('div', {
    staticClass: "l-clearfix collision-fields"
  }, [(_vm.collision.people) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.collision.people) + " " + _vm._s(_vm.collision.people > 1 ? 'people' : 'person') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.pedestrians) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_walk")]), _vm._v(" " + _vm._s(_vm.collision.pedestrians) + " " + _vm._s(_vm.collision.pedestrians > 1 ? 'pedestrians' : 'pedestrian') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.cyclists) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_bike")]), _vm._v(" " + _vm._s(_vm.collision.cyclists) + " " + _vm._s(_vm.collision.cyclists > 1 ? 'cyclists' : 'cyclist') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.vehicles) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_car")]), _vm._v(" " + _vm._s(_vm.collision.vehicles) + " " + _vm._s(_vm.collision.vehicles > 1 ? 'vehicles' : 'vehicle') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.injuries) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Injuries")]), _vm._v(" " + _vm._s(_vm.collision.injuries) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.serious_injuries) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Serious injuries")]), _vm._v(" " + _vm._s(_vm.collision.serious_injuries) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.fatalities) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Fatalities")]), _vm._v(" " + _vm._s(_vm.collision.fatalities) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.light_condition) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Light conditions")]), _vm._v("\n            " + _vm._s(_vm.collision.light_condition) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.hitparkedcar) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Hit parked car?")]), _vm._v(" Yes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.road_condition) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Road conditions")]), _vm._v("\n            " + _vm._s(_vm.collision.road_condition) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.speeding) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Speeding")]), _vm._v(" Yes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.under_influence) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Under the influence of drugs or alcohol")]), _vm._v(" Yes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.weather) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Weather")]), _vm._v("\n            " + _vm._s(_vm.collision.weather) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.address_type) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Address type")]), _vm._v("\n            " + _vm._s(_vm.collision.address_type) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.coldetkey) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Collision detail key")]), _vm._v("\n            " + _vm._s(_vm.collision.coldetkey) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.collision_type) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Collision type")]), _vm._v("\n            " + _vm._s(_vm.collision.collision_type) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.junction_type) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Junction type")]), _vm._v("\n            " + _vm._s(_vm.collision.junction_type) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.inattention) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Due to inattention?")]), _vm._v(" " + _vm._s(_vm.collision.inattention) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.inckey) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Incident key")]), _vm._v("\n            " + _vm._s(_vm.collision.inckey) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.reportno) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Report number")]), _vm._v("\n            " + _vm._s(_vm.collision.reportno) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.sdot) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("SDOT code " + _vm._s(_vm.collision.sdot.collision_code))]), _vm._v(" "), (_vm.collision.sdot.collision_title) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.collision.sdot.collision_title) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.collision.severity.code) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Severity code " + _vm._s(_vm.collision.severity.code))]), _vm._v("\n            " + _vm._s(_vm.collision.severity.description) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.spd_case_number) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("SPD case number")]), _vm._v("\n            " + _vm._s(_vm.collision.spd_case_number) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.state_collision_code) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("State collision code")]), _vm._v("\n            " + _vm._s(_vm.collision.state_collision_code) + "\n        ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    class: [{
      's-full-list-active': _vm.fullListActive
    }]
  }, [_c('h1', [_c('span', [_vm._v("Seattle city council districts")]), _vm._v(" between "), _c('span', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" and "), _c('span', [_vm._v(_vm._s(_vm.endDate))]), _vm._v(" with the "), _c('strong', [_vm._v("highest")]), _vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "well collisions-filters"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "well-content"
  }, [_c('FilterDate', {
    attrs: {
      "default-option": {
        key: 'all',
        label: 'Since January 1st, 2006'
      }
    }
  }), _vm._v(" "), _c('FilterSubmitButton', {
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "routeName": 'cityCouncilDistrictRanks',
      "routeParams": _vm.routeParams
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-medium"
  }, [_c('Costs', {
    attrs: {
      "card-color": 'green',
      "card-icon": 'attach_money',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/costs/economic/desc',
        pageTitle: 'Seattle economic costs by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Economic costs',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        titleIcon: 'attach_money',
        color: 'green',
        prefix: '$',
        barColors: this.$store.getters.green.light.a
      },
      "getter": 'cityCouncilDistrictRanksView/costs/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a,
      "legend-color": 'green',
      "legend-link": 'cityCouncilDistrict',
      "label-prefix": ' $'
    }
  }), _vm._v(" "), _c('TotalCollisions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'flare',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/totalcollisions/desc',
        pageTitle: 'Seattle total collisions by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Total collisions',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        titleIcon: 'warning',
        color: 'yellow',
        barColors: this.$store.getters.yellow.default
      },
      "getter": 'cityCouncilDistrictRanksView/totalCollisions/get',
      "title": 'Total collisions',
      "bar-color": this.$store.getters.yellow.default,
      "legend-color": 'yellow',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('Fatalities', {
    attrs: {
      "card-color": 'black',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/severity/5/desc',
        pageTitle: 'Seattle fatalities by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Fatalities',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'black',
        barColors: this.$store.getters.black.dark.b
      },
      "getter": 'cityCouncilDistrictRanksView/fatalities/get',
      "title": 'Fatalities',
      "bar-color": this.$store.getters.black.dark.b,
      "legend-color": 'black',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('SeriousInjuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/severity/4/desc',
        pageTitle: 'Seattle serious injuries by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Serious injuries',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'red',
        barColors: this.$store.getters.red.dark.b
      },
      "getter": 'cityCouncilDistrictRanksView/seriousInjuries/get',
      "title": 'Number of serious injuries',
      "bar-color": this.$store.getters.red.dark.b,
      "legend-color": 'red',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('Injuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/severity/1/desc',
        pageTitle: 'Seattle injuries by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Injuries',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'red',
        barColors: this.$store.getters.red.dark.a
      },
      "getter": 'cityCouncilDistrictRanksView/injuries/get',
      "title": 'Number of injuries',
      "bar-color": this.$store.getters.red.dark.a,
      "legend-color": 'red',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('PossibleInjuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/severity/3/desc',
        pageTitle: 'Seattle possible injuries by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'possible injuries',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'red',
        barColors: this.$store.getters.red.light.b
      },
      "getter": 'cityCouncilDistrictRanksView/possibleInjuries/get',
      "title": 'Collisions with possible injuries',
      "bar-color": this.$store.getters.red.light.b,
      "legend-color": 'red',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('PeopleInvolved', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'person',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/personcount/desc',
        pageTitle: 'Seattle people involved by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'People involved',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'orange',
        barColors: this.$store.getters.orange.dark.a
      },
      "getter": 'cityCouncilDistrictRanksView/possibleInjuries/get',
      "title": 'Number of people involved',
      "bar-color": this.$store.getters.orange.dark.a,
      "legend-color": 'orange',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('PeopleWalking', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'directions_walk',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/pedcount/desc',
        pageTitle: 'Seattle pedestrians involved by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Pedestrians involved',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'orange',
        barColors: this.$store.getters.orange.light.a
      },
      "getter": 'cityCouncilDistrictRanksView/peopleWalking/get',
      "title": 'Number of pedestrians involved',
      "bar-color": this.$store.getters.orange.light.a,
      "legend-color": 'orange',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('PeopleBiking', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'directions_bike',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/pedcylcount/desc',
        pageTitle: 'Seattle people biking by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'People biking',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'orange',
        barColors: this.$store.getters.orange.light.b
      },
      "getter": 'cityCouncilDistrictRanksView/peopleBiking/get',
      "title": 'Number of people biking involved',
      "bar-color": this.$store.getters.orange.light.b,
      "legend-color": 'orange',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('DistractedDriving', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'visibility_off',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/inattentionind/desc',
        pageTitle: 'Seattle distracted driving by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Distracted driving',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'purple',
        barColors: this.$store.getters.purple.dark.a
      },
      "getter": 'cityCouncilDistrictRanksView/distractedDriving/get',
      "title": 'Cases of distracted driving',
      "bar-color": this.$store.getters.purple.dark.a,
      "legend-color": 'purple',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('UnderTheInfluence', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'blur_on',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/underinfl/desc',
        pageTitle: 'Seattle DUI by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Driving under the influence',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'purple',
        barColors: this.$store.getters.purple.light.a
      },
      "getter": 'cityCouncilDistrictRanksView/underTheInfluence/get',
      "title": 'Cases of DUI',
      "bar-color": this.$store.getters.purple.light.a,
      "legend-color": 'purple',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('PropertyDamageOnly', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'toll',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/severity/2/desc',
        pageTitle: 'Seattle property damage only by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Property damage only',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'blue',
        barColors: this.$store.getters.blue.light.a
      },
      "getter": 'cityCouncilDistrictRanksView/propertyDamageOnly/get',
      "title": 'Property damage only collisions',
      "bar-color": this.$store.getters.blue.light.a,
      "legend-color": 'blue',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('ParkedCarsHit', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'local_parking',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/hitparkedcar/desc',
        pageTitle: 'Seattle parked cars hit by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Parked cars hit',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'blue',
        barColors: this.$store.getters.blue.light.a
      },
      "getter": 'cityCouncilDistrictRanksView/parkedCarsHit/get',
      "title": 'Number of parked cars hit',
      "bar-color": this.$store.getters.blue.light.a,
      "legend-color": 'blue',
      "legend-link": 'cityCouncilDistrict'
    }
  }), _vm._v(" "), _c('Speeding', {
    attrs: {
      "card-color": 'teal',
      "card-icon": 'fast_forward',
      "full-list-toggle-dispatch": 'cityCouncilDistrictRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'cityCouncilDistrictRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/districts/city/ranks/who/speeding/desc',
        pageTitle: 'Seattle speeding by city council district between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Speeding',
        ths: ['Rank', 'Council district', 'Amount'],
        link: 'cityCouncilDistrict',
        color: 'teal',
        barColors: this.$store.getters.teal.light.a
      },
      "getter": 'cityCouncilDistrictRanksView/speeding/get',
      "title": 'Cases of speeding',
      "bar-color": this.$store.getters.teal.light.a,
      "legend-color": 'teal',
      "legend-link": 'cityCouncilDistrict'
    }
  })], 1), _vm._v(" "), _c('SeattleCityCouncilInformation'), _vm._v(" "), _c('FullList', {
    attrs: {
      "getters": {
        active: 'cityCouncilDistrictRanksView/fullList/active',
        fetch: 'cityCouncilDistrictRanksView/fullList/fetch',
        filters: 'cityCouncilDistrictRanksView/fullList/filters',
        get: 'cityCouncilDistrictRanksView/fullList/get',
        options: 'cityCouncilDistrictRanksView/fullList/options',
        reset: 'cityCouncilDistrictRanksView/fullList/reset',
        toggleActive: 'cityCouncilDistrictRanksView/fullList/toggleActive'
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "well-title collisions-filters-title"
  }, [_c('span', [_vm._v("Filter collisions")])])
}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-height-100"
  }, [_c('Geo', {
    ref: "geo",
    attrs: {
      "map-data": _vm.collisionLocations,
      "marker-click-action": 'collisionsView/collision/fetch',
      "map-active": _vm.mapActive
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Seattle City Council Districts")]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-xsmall"
  }, [_vm._l((_vm.districts), function(district) {
    return _c('div', {
      staticClass: "card"
    }, [_c('h2', {
      staticClass: "card-h2"
    }, [_c('span', [_vm._v(_vm._s(district.name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('router-link', {
      staticClass: "l-width-100 btn teal",
      attrs: {
        "to": {
          name: 'cityCouncilDistrict',
          params: {
            id: district.id
          }
        }
      }
    }, [_vm._v("View " + _vm._s(district.name))]), _vm._v(" "), _c('h3', [_vm._v("Neighborhoods")]), _vm._v(" "), _c('ul', _vm._l((district.neighborhoods), function(neighborhoodName, neighborhoodSlug) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: 'neighborhood',
            params: {
              id: neighborhoodSlug
            }
          }
        }
      }, [_vm._v(_vm._s(neighborhoodName))])], 1)
    }))], 1)])
  }), _vm._v(" "), _c('SeattleCityCouncilInformation')], 2), _vm._v(" "), _c('Geo', {
    attrs: {
      "polygons": _vm.polygons
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm.neighborhoodInfo.name))]), _vm._v(" collisions since "), _c('span', [_vm._v("January 1, 2006")])]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-large"
  }, [_c('MonthlyCollisions', {
    attrs: {
      "getters": {
        average: 'neighborhoodView/monthlyCollisions/average',
        monthlyCollisions: 'neighborhoodView/monthlyCollisions/get',
        total: 'neighborhoodView/monthlyCollisions/total'
      }
    }
  }), _vm._v(" "), _c('DamageCosts', {
    attrs: {
      "getter": 'neighborhoodView/damageCosts/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-small"
  }, [_c('WhoRank', {
    attrs: {
      "getters": {
        rankings: 'neighborhoodView/whoRank/get'
      }
    }
  }), _vm._v(" "), _c('SeverityRank', {
    attrs: {
      "getters": {
        rankings: 'neighborhoodView/severityRank/get'
      }
    }
  }), _vm._v(" "), _c('Weather', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'cloud',
      "getter": 'neighborhoodView/weather/get',
      "table-color": 'blue',
      "title": 'Weather',
      "bar-color": this.$store.getters.blue.light.a,
      "chart-height": 380,
      "x-min-axes-rotation": 75
    }
  }), _vm._v(" "), _c('RoadConditions', {
    attrs: {
      "card-color": 'orange',
      "getter": 'neighborhoodView/roadConditions/get',
      "table-color": 'orange',
      "title": 'Road conditions',
      "bar-color": this.$store.getters.orange.light.a
    }
  }), _vm._v(" "), _c('LightConditions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'wb_incandescent',
      "getter": 'neighborhoodView/lightConditions/get',
      "table-color": 'yellow',
      "title": 'Light conditions',
      "bar-color": this.$store.getters.yellow.light.a
    }
  }), _vm._v(" "), _c('CollisionTypes', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'call_split',
      "getter": 'neighborhoodView/collisionTypes/get',
      "table-color": 'purple',
      "title": 'Collision types',
      "bar-color": this.$store.getters.purple.light.a
    }
  }), _vm._v(" "), _c('JunctionTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'neighborhoodView/junctionTypes/get',
      "table-color": 'teal',
      "title": 'Junction types',
      "bar-color": this.$store.getters.teal.light.b,
      "chart-height": 520,
      "x-min-axes-rotation": 80
    }
  }), _vm._v(" "), _c('AddressTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'neighborhoodView/addressTypes/get',
      "table-color": 'teal',
      "title": 'Address types',
      "bar-color": this.$store.getters.teal.light.b
    }
  })], 1), _vm._v(" "), _c('SeattleCityCouncilInformation'), _vm._v(" "), _c('Geo', {
    attrs: {
      "multipolygons": _vm.multipolygons
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[252]);


// WEBPACK FOOTER //
// static/js/app.cde97de951a69b9a9da4.js